// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HostingSiteAddV3BodyDatacenter = {
    'Amsterdam,_Netherlands': 'Amsterdam, Netherlands',
    'Ashburn,_Virginia': 'Ashburn, Virginia',
    'Dallas,_Texas': 'Dallas, Texas',
    'Los_Angeles,_California': 'Los Angeles, California',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BackupStatusV3200CbsEventProcessingPlanType = {
    free: 'free',
    premium: 'premium',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BackupRestoreV3BodyUserConsent = {
    NUMBER_0: 0,
    NUMBER_1: 1,
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BackupRestoreV3BodyPlanType = {
    free: 'free',
    premium: 'premium',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BackupRestoreV3BodyBackupType = {
    home: 'home',
    db: 'db',
    home_db: 'home_db',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BackupRestoreV3BodyBackupPreRestore = {
    NUMBER_0: 0,
    NUMBER_1: 1,
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BackupCreateV3BodyBackupType = {
    home: 'home',
    db: 'db',
    home_db: 'home_db',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SitesSecuritySitelockV2Source = {
    hal: 'hal',
    fg: 'fg',
    halfg: 'halfg',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SshKeyV2BodyRemote = {
    NUMBER_0: 0,
    NUMBER_1: 1,
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HostingSiteAddV2BodyDatacenter = {
    'Amsterdam,_Netherlands': 'Amsterdam, Netherlands',
    'Ashburn,_Virginia': 'Ashburn, Virginia',
    'Dallas,_Texas': 'Dallas, Texas',
    'Los_Angeles,_California': 'Los Angeles, California',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HostingDomainsV2TypesItem = {
    addon: 'addon',
    link: 'link',
    main: 'main',
    parked: 'parked',
    sub: 'sub',
    unassigned: 'unassigned',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BackupDownloadV2BodyPlanType = {
    free: 'free',
    premium: 'premium',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BackupDownloadV2BodyBackupType = {
    home: 'home',
    db: 'db',
    home_db: 'home_db',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserPhoneSmsConsentUpdate400Error = {
    userPhoneNotFound: 'userPhoneNotFound',
    optioConsentNotFound: 'optioConsentNotFound',
    optioInvalidInput: 'optioInvalidInput',
    brandRequired: 'brandRequired',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserPhoneSmsConsentUpdateBodyOptInStatus = {
    Granted: 'Granted',
    Revoked: 'Revoked',
    NoAnswer: 'NoAnswer',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserPhoneSmsConsentUpdateBodyConsentType = {
    marketing: 'marketing',
    transaction: 'transaction',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserPhoneSmsConsentConsentType = {
    marketing: 'marketing',
    transaction: 'transaction',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SiteAddonWpsolutionBodySubtype = {
    creator: 'creator',
    commerce: 'commerce',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SitesSsoBounceName = {
    jetpackbackup: 'jetpackbackup',
    jetpackdashboard: 'jetpackdashboard',
    staging: 'staging',
    updatecore: 'updatecore',
    password: 'password',
    profile: 'profile',
    plugins: 'plugins',
    themes: 'themes',
    phpmyadmin: 'phpmyadmin',
    filemanager: 'filemanager',
    store: 'store',
    wpmigration: 'wpmigration',
    mypluginsandtools: 'mypluginsandtools',
    blu_ai_store: 'blu_ai_store',
    blu_wvc_editor: 'blu_wvc_editor',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SitesSecuritySitelockSource = {
    hal: 'hal',
    fg: 'fg',
    halfg: 'halfg',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SiteQualityMetricsStrategy = {
    MOBILE: 'MOBILE',
    DESKTOP: 'DESKTOP',
    STRATEGY_UNSPECIFIED: 'STRATEGY_UNSPECIFIED',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SitesErrorLogsDownloadSort = {
    asc: 'asc',
    desc: 'desc',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SitesErrorLogsSort = {
    asc: 'asc',
    desc: 'desc',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SitesAccessLogsDownloadSort = {
    asc: 'asc',
    desc: 'desc',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SitesAccessLogsSort = {
    asc: 'asc',
    desc: 'desc',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SitesAutoupdatesUpdateBodyType = {
    core: 'core',
    plugins: 'plugins',
    themes: 'themes',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SiteUpdateBodyVersionPtr = {
    latest: 'latest',
    previous: 'previous',
    beta: 'beta',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AccountPurchaseOrder200OrderStatus = {
    processing: 'processing',
    pending: 'pending',
    partially_complete: 'partially_complete',
    completed: 'completed',
    failed: 'failed',
    deferred: 'deferred',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AccountPurchaseOrder200HostingStatus = {
    pending: 'pending',
    active: 'active',
    failed: 'failed',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HostingVisitorsSource = {
    http: 'http',
    https: 'https',
    combined: 'combined',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HostingVisitorsInterval = {
    NUMBER_1: 1,
    NUMBER_24: 24,
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SsoApp = {
    accesslogs: 'accesslogs',
    awstats: 'awstats',
    cronjobs: 'cronjobs',
    domainredirects: 'domainredirects',
    directoryprivacy: 'directoryprivacy',
    errorlogs: 'errorlogs',
    emailaccounts: 'emailaccounts',
    emailforwarders: 'emailforwarders',
    emailfilters: 'emailfilters',
    emailglobalfilters: 'emailglobalfilters',
    emailspamfilters: 'emailspamfilters',
    emailautoresponders: 'emailautoresponders',
    emailrouting: 'emailrouting',
    ftp: 'ftp',
    filemanager: 'filemanager',
    ipblocker: 'ipblocker',
    indexmanager: 'indexmanager',
    mysql: 'mysql',
    phpmyadmin: 'phpmyadmin',
    sshkeys: 'sshkeys',
    sslsigningrequests: 'sslsigningrequests',
    ssluploadcert: 'ssluploadcert',
    sslviewlogs: 'sslviewlogs',
    sslmanager: 'sslmanager',
    softaculous: 'softaculous',
    zoneeditor: 'zoneeditor',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SshKeyGenerateBodyEncType = {
    rsa: 'rsa',
    dsa: 'dsa',
    ed25519: 'ed25519',
    ecdsa: 'ecdsa',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SshKeyGenerateBodyBits = {
    NUMBER_1024: 1024,
    NUMBER_2048: 2048,
    NUMBER_4096: 4096,
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HostingSiteAddBodyDatacenter = {
    'Amsterdam,_Netherlands': 'Amsterdam, Netherlands',
    'Ashburn,_Virginia': 'Ashburn, Virginia',
    'Dallas,_Texas': 'Dallas, Texas',
    'Los_Angeles,_California': 'Los Angeles, California',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProductLicenseDetailsProductName = {
    wpsolution: 'wpsolution',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HostingMigrationsEventBodyEventName = {
    inReview: 'inReview',
    approved: 'approved',
    disapproved: 'disapproved',
    propagationComplete: 'propagationComplete',
    propagationTimeout: 'propagationTimeout',
    transferComplete: 'transferComplete',
    failedCreate: 'failedCreate',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AddIndexBodyType = {
    fancy: 'fancy',
    standard: 'standard',
    default: 'default',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AddIndexBodyAction = {
    view: 'view',
    enable: 'enable',
    disable: 'disable',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HostingFtpUpdateBodyUserTypeSet = {
    password: 'password',
    quota: 'quota',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HostingEmailSpamSettingsUpdateBodySetting = {
    auto_delete: 'auto_delete',
    spam: 'spam',
    spam_box: 'spam_box',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HostingEmailSpamCustomSettingsUpdateBodyType = {
    allowlist: 'allowlist',
    blocklist: 'blocklist',
    custom_scores: 'custom_scores',
    spam_score: 'spam_score',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HostingEmailSettingsBodyUtf8Folders = {
    enable: 'enable',
    disable: 'disable',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HostingEmailSettingsBodyType = {
    address: 'address',
    system: 'system',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HostingEmailSettingsBodyAutofolders = {
    enable: 'enable',
    disable: 'disable',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HostingEmailSettingsBodyAccountOutgoing = {
    hold: 'hold',
    suspend: 'suspend',
    unsuspend: 'unsuspend',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HostingEmailSettingsBodyAccountLogin = {
    suspend: 'suspend',
    unsuspend: 'unsuspend',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HostingEmailSettingsBodyAccountIncoming = {
    suspend: 'suspend',
    unsuspend: 'unsuspend',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HostingEmailDomainRoutingSetBodyRouteType = {
    local: 'local',
    remote: 'remote',
    auto: 'auto',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HostingEmailKeysAddBodyKeysize = {
    NUMBER_1024: 1024,
    NUMBER_2048: 2048,
    NUMBER_3072: 3072,
    NUMBER_4096: 4096,
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HostingEmailForwardDeleteType = {
    account: 'account',
    domain: 'domain',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HostingEmailForwarderAddBodyType = {
    account: 'account',
    domain: 'domain',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HostingEmailForwarderAddBodyDestinationType = {
    alias: 'alias',
    alias_unknown: 'alias_unknown',
    discard: 'discard',
    blackhole: 'blackhole',
    forward: 'forward',
    pipe: 'pipe',
    system: 'system',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HostingEmailForwardersListType = {
    account: 'account',
    domain: 'domain',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HostingEmailAddBodyType = {
    box: 'box',
    domainalias: 'domainalias',
    alias: 'alias',
    forwarder: 'forwarder',
    discard: 'discard',
    pipe: 'pipe',
    list: 'list',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DomainsType = {
    addon: 'addon',
    link: 'link',
    main: 'main',
    parked: 'parked',
    sub: 'sub',
    unassigned: 'unassigned',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EditPrivacyBodyAction = {
    view: 'view',
    enable: 'enable',
    disable: 'disable',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PrivacyBodyAction = {
    view: 'view',
    enable: 'enable',
    disable: 'disable',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AddPrivacyBodyAction = {
    view: 'view',
    enable: 'enable',
    disable: 'disable',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DbUserAddBodyDbType = {
    mysql: 'mysql',
    postgres: 'postgres',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DbUserPrivsSetBodyType = {
    mysql: 'mysql',
    postgres: 'postgres',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DbCheckDatabaseBodyType = {
    mysql: 'mysql',
    postgres: 'postgres',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DbBodyType = {
    mysql: 'mysql',
    postgres: 'postgres',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DbAddBodyType = {
    mysql: 'mysql',
    postgres: 'postgres',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HostingAdvancedConsoleProtocol = {
    ssh: 'ssh',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateDomainResourceRecordsBodyResourceRecordsToRemoveItemType = {
    A: 'A',
    AAAA: 'AAAA',
    NS: 'NS',
    MX: 'MX',
    CNAME: 'CNAME',
    TXT: 'TXT',
    SRV: 'SRV',
    CAA: 'CAA',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateDomainResourceRecordsBodyResourceRecordsToAddItemType = {
    A: 'A',
    AAAA: 'AAAA',
    NS: 'NS',
    MX: 'MX',
    CNAME: 'CNAME',
    TXT: 'TXT',
    SRV: 'SRV',
    CAA: 'CAA',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DomainResourceRecordsRecordType = {
    A: 'A',
    AAAA: 'AAAA',
    NS: 'NS',
    MX: 'MX',
    CNAME: 'CNAME',
    TXT: 'TXT',
    SRV: 'SRV',
    CAA: 'CAA',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AccessLogsType = {
    error: 'error',
    all: 'all',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DomainHealthCacheMode = {
    auto: 'auto',
    cache_only: 'cache_only',
    live: 'live',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DomainHealthInclude = {
    public: 'public',
    box: 'box',
    xns: 'xns',
    registrar: 'registrar',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DomainHealthChecksItem = {
    hosting: 'hosting',
    email: 'email',
    ssl: 'ssl',
    site: 'site',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BackupPrefSetStatusBodyStatus = {
    enable: 'enable',
    disable: 'disable',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BackupCreateOndemandV1BodyIncludeBackupTarLink = {
    NUMBER_0: 0,
    NUMBER_1: 1,
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BackupCreateOndemandV1BodyBackupType = {
    home: 'home',
    db: 'db',
    home_db: 'home_db',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BackupMeta200SiteCbsRestoreConsentInfoPlanType = {
    free: 'free',
    premium: 'premium',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BackupMeta200SiteCbsDownloadablesItemPlanType = {
    free: 'free',
    premium: 'premium',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BackupMeta200SiteCbsBackupDeleteDataPlanType = {
    free: 'free',
    premium: 'premium',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BackupMeta200AccountCbsEventProcessingPlanType = {
    free: 'free',
    premium: 'premium',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BackupListBackupType = {
    full: 'full',
    home: 'home',
    mysql: 'mysql',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BackupInitiateBodyBackupType = {
    home: 'home',
    mysql: 'mysql',
    full: 'full',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BackupNotificationsEmailSuccessfulBackups = {
    NUMBER_0: 0,
    NUMBER_1: 1,
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BackupNotificationsEmailStorageLimit = {
    NUMBER_0: 0,
    NUMBER_1: 1,
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BackupNotificationsEmailGeneralNotifications = {
    NUMBER_0: 0,
    NUMBER_1: 1,
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BackupNotificationsEmailFailedBackups = {
    NUMBER_0: 0,
    NUMBER_1: 1,
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnnouncementSeverity = {
    NEUTRAL: 'NEUTRAL',
    SUCCESS: 'SUCCESS',
    WARNING: 'WARNING',
    ERROR: 'ERROR',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HostingRollbackResponseStatus = {
    queued: 'queued',
    duplicate: 'duplicate',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HostingRedeployResponseStatus = {
    queued: 'queued',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HostingConfigSetVariableRequestKind = {
    plain: 'plain',
    secret: 'secret',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HostingConfigVariableItemStatus = {
    set: 'set',
    missing: 'missing',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HostingConfigVariableItemKind = {
    plain: 'plain',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HostingConfigVariableItemAction = {
    edit: 'edit',
    set_value: 'set_value',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HostingConfigSecretItemStatus = {
    set: 'set',
    missing: 'missing',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HostingConfigSecretItemKind = {
    secret: 'secret',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HostingConfigSecretItemAction = {
    replace: 'replace',
    set_value: 'set_value',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HostingApplicationSslStatus = {
    active: 'active',
    unknown: 'unknown',
    none: 'none',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HostingApplicationActionsBlockReason = {
    deployment_in_flight: 'deployment_in_flight',
    config_incomplete: 'config_incomplete',
    no_deployment: 'no_deployment',
    no_rollback_target: 'no_rollback_target',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HostingApplicationBannerTone = {
    info: 'info',
    danger: 'danger',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HostingApplicationBannerKind = {
    deployment_in_flight: 'deployment_in_flight',
    rollback_in_progress: 'rollback_in_progress',
    terminal_failure: 'terminal_failure',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HostingApplicationListItemStatus = {
    accepted: 'accepted',
    staging: 'staging',
    health_check: 'health_check',
    active: 'active',
    rolling_back: 'rolling_back',
    rolled_back: 'rolled_back',
    terminal_failure: 'terminal_failure',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AutoresponderCharset = {
    'ansi_x3110-1983': 'ansi_x3.110-1983',
    'ansi_x34-1968': 'ansi_x3.4-1968',
    'armscii-8': 'armscii-8',
    asmo_449: 'asmo_449',
    big5: 'big5',
    'big5-hkscs': 'big5-hkscs',
    brf: 'brf',
    bs_4730: 'bs_4730',
    cp10007: 'cp10007',
    cp1125: 'cp1125',
    cp1250: 'cp1250',
    cp1253: 'cp1253',
    cp1254: 'cp1254',
    cp1255: 'cp1255',
    cp1256: 'cp1256',
    cp1257: 'cp1257',
    cp1258: 'cp1258',
    cp737: 'cp737',
    cp770: 'cp770',
    cp771: 'cp771',
    cp772: 'cp772',
    cp773: 'cp773',
    cp774: 'cp774',
    cp775: 'cp775',
    'csa_z2434-1985-1': 'csa_z243.4-1985-1',
    'csa_z2434-1985-2': 'csa_z243.4-1985-2',
    csn_369103: 'csn_369103',
    cwi: 'cwi',
    'dec-mcs': 'dec-mcs',
    din_66003: 'din_66003',
    ds_2089: 'ds_2089',
    'ebcdic-at-de': 'ebcdic-at-de',
    'ebcdic-at-de-a': 'ebcdic-at-de-a',
    'ebcdic-ca-fr': 'ebcdic-ca-fr',
    'ebcdic-dk-no': 'ebcdic-dk-no',
    'ebcdic-dk-no-a': 'ebcdic-dk-no-a',
    'ebcdic-es': 'ebcdic-es',
    'ebcdic-es-a': 'ebcdic-es-a',
    'ebcdic-es-s': 'ebcdic-es-s',
    'ebcdic-fi-se': 'ebcdic-fi-se',
    'ebcdic-fi-se-a': 'ebcdic-fi-se-a',
    'ebcdic-fr': 'ebcdic-fr',
    'ebcdic-is-friss': 'ebcdic-is-friss',
    'ebcdic-it': 'ebcdic-it',
    'ebcdic-pt': 'ebcdic-pt',
    'ebcdic-uk': 'ebcdic-uk',
    'ebcdic-us': 'ebcdic-us',
    'ecma-cyrillic': 'ecma-cyrillic',
    es: 'es',
    es2: 'es2',
    'euc-jisx0213': 'euc-jisx0213',
    'euc-jp': 'euc-jp',
    'euc-jp-ms': 'euc-jp-ms',
    'euc-kr': 'euc-kr',
    'euc-tw': 'euc-tw',
    gb18030: 'gb18030',
    gb2312: 'gb2312',
    'gb_1988-80': 'gb_1988-80',
    gbk: 'gbk',
    'georgian-academy': 'georgian-academy',
    'georgian-ps': 'georgian-ps',
    'gost_19768-74': 'gost_19768-74',
    'greek-ccitt': 'greek-ccitt',
    greek7: 'greek7',
    'greek7-old': 'greek7-old',
    'hp-greek8': 'hp-greek8',
    'hp-roman8': 'hp-roman8',
    'hp-roman9': 'hp-roman9',
    'hp-thai8': 'hp-thai8',
    'hp-turkish8': 'hp-turkish8',
    ibm037: 'ibm037',
    ibm038: 'ibm038',
    ibm1004: 'ibm1004',
    ibm1026: 'ibm1026',
    ibm1047: 'ibm1047',
    ibm1124: 'ibm1124',
    ibm1129: 'ibm1129',
    ibm1132: 'ibm1132',
    ibm1133: 'ibm1133',
    ibm1160: 'ibm1160',
    ibm1161: 'ibm1161',
    ibm1162: 'ibm1162',
    ibm1163: 'ibm1163',
    ibm1164: 'ibm1164',
    ibm256: 'ibm256',
    ibm273: 'ibm273',
    ibm274: 'ibm274',
    ibm275: 'ibm275',
    ibm277: 'ibm277',
    ibm278: 'ibm278',
    ibm280: 'ibm280',
    ibm281: 'ibm281',
    ibm284: 'ibm284',
    ibm285: 'ibm285',
    ibm290: 'ibm290',
    ibm297: 'ibm297',
    ibm420: 'ibm420',
    ibm423: 'ibm423',
    ibm424: 'ibm424',
    ibm437: 'ibm437',
    ibm500: 'ibm500',
    ibm850: 'ibm850',
    ibm851: 'ibm851',
    ibm852: 'ibm852',
    ibm855: 'ibm855',
    ibm856: 'ibm856',
    ibm857: 'ibm857',
    ibm858: 'ibm858',
    ibm860: 'ibm860',
    ibm861: 'ibm861',
    ibm862: 'ibm862',
    ibm863: 'ibm863',
    ibm864: 'ibm864',
    ibm865: 'ibm865',
    ibm866: 'ibm866',
    ibm866nav: 'ibm866nav',
    ibm868: 'ibm868',
    ibm869: 'ibm869',
    ibm870: 'ibm870',
    ibm871: 'ibm871',
    ibm874: 'ibm874',
    ibm875: 'ibm875',
    ibm880: 'ibm880',
    ibm891: 'ibm891',
    ibm903: 'ibm903',
    ibm904: 'ibm904',
    ibm905: 'ibm905',
    ibm918: 'ibm918',
    ibm922: 'ibm922',
    'iec_p27-1': 'iec_p27-1',
    inis: 'inis',
    'inis-8': 'inis-8',
    'inis-cyrillic': 'inis-cyrillic',
    'isiri-3342': 'isiri-3342',
    'iso-8859-1': 'iso-8859-1',
    'iso-8859-10': 'iso-8859-10',
    'iso-8859-11': 'iso-8859-11',
    'iso-8859-13': 'iso-8859-13',
    'iso-8859-14': 'iso-8859-14',
    'iso-8859-15': 'iso-8859-15',
    'iso-8859-16': 'iso-8859-16',
    'iso-8859-2': 'iso-8859-2',
    'iso-8859-3': 'iso-8859-3',
    'iso-8859-4': 'iso-8859-4',
    'iso-8859-5': 'iso-8859-5',
    'iso-8859-6': 'iso-8859-6',
    'iso-8859-7': 'iso-8859-7',
    'iso-8859-8': 'iso-8859-8',
    'iso-8859-9': 'iso-8859-9',
    'iso-8859-9e': 'iso-8859-9e',
    'iso-ir-197': 'iso-ir-197',
    'iso-ir-209': 'iso-ir-209',
    'iso-ir-90': 'iso-ir-90',
    'iso_10367-box': 'iso_10367-box',
    'iso_11548-1': 'iso_11548-1',
    'iso_2033-1983': 'iso_2033-1983',
    iso_5427: 'iso_5427',
    'iso_5427-ext': 'iso_5427-ext',
    iso_5428: 'iso_5428',
    iso_6937: 'iso_6937',
    it: 'it',
    'jis_c6220-1969-ro': 'jis_c6220-1969-ro',
    'jis_c6229-1984-b': 'jis_c6229-1984-b',
    johab: 'johab',
    jus_ib1002: 'jus_i.b1.002',
    'koi-8': 'koi-8',
    'koi8-r': 'koi8-r',
    'koi8-ru': 'koi8-ru',
    'koi8-t': 'koi8-t',
    'koi8-u': 'koi8-u',
    ksc5636: 'ksc5636',
    'latin-greek': 'latin-greek',
    'latin-greek-1': 'latin-greek-1',
    'mac-centraleurope': 'mac-centraleurope',
    'mac-cyrillic': 'mac-cyrillic',
    'mac-is': 'mac-is',
    'mac-sami': 'mac-sami',
    'mac-uk': 'mac-uk',
    macintosh: 'macintosh',
    mik: 'mik',
    msz_77953: 'msz_7795.3',
    'nats-dano': 'nats-dano',
    'nats-sefi': 'nats-sefi',
    'nc_nc00-10': 'nc_nc00-10',
    'nf_z_62-010': 'nf_z_62-010',
    'nf_z_62-010_1973': 'nf_z_62-010_1973',
    'ns_4551-1': 'ns_4551-1',
    'ns_4551-2': 'ns_4551-2',
    pt: 'pt',
    pt154: 'pt154',
    pt2: 'pt2',
    rk1048: 'rk1048',
    sen_850200_b: 'sen_850200_b',
    sen_850200_c: 'sen_850200_c',
    shift_jis: 'shift_jis',
    shift_jisx0213: 'shift_jisx0213',
    't61-8bit': 't.61-8bit',
    'tcvn5712-1': 'tcvn5712-1',
    'tis-620': 'tis-620',
    tscii: 'tscii',
    'us-ascii': 'us-ascii',
    'utf-7': 'utf-7',
    'utf-8': 'utf-8',
    viscii: 'viscii',
    'windows-1251': 'windows-1251',
    'windows-1252': 'windows-1252',
    'windows-31j': 'windows-31j',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FilterRuleOpt = {
    or: 'or',
    and: 'and',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FilterRuleMatch = {
    matches: 'matches',
    does_not_match: 'does not match',
    contains: 'contains',
    does_not_contain: 'does not contain',
    begins: 'begins',
    does_not_begin: 'does not begin',
    ends: 'ends',
    does_not_end: 'does not end',
    is_above: 'is above',
    is_not_above: 'is not above',
    is_below: 'is below',
    is_not_below: 'is not below',
    equals: 'equals',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FilterRulePart = {
    spam_bar: 'spam_bar',
    spam_score: 'spam_score',
    spam_status: 'spam_status',
    list_id: 'list_id',
    from: 'from',
    subject: 'subject',
    to: 'to',
    reply_to_or_to: 'reply_to_or_to',
    body: 'body',
    any_header: 'any_header',
    faa_to_or_cc: 'faa_to_or_cc',
    not_delivered: 'not_delivered',
    error_message: 'error_message',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FilterAction = {
    fail: 'fail',
    finish: 'finish',
    deliver: 'deliver',
    pipe: 'pipe',
    save: 'save',
    blackhole: 'blackhole',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SpamCustomScoreSubtypes = {
    ACCESSDB: 'ACCESSDB',
    ACCT_PHISHING: 'ACCT_PHISHING',
    ACCT_PHISHING_MANY: 'ACCT_PHISHING_MANY',
    ACH_CANCELLED: 'ACH_CANCELLED',
    ACH_CANCELLED_EXE: 'ACH_CANCELLED_EXE',
    ACT_NOW_CAPS: 'ACT_NOW_CAPS',
    AC_BR_BONANZA: 'AC_BR_BONANZA',
    AC_DIV_BONANZA: 'AC_DIV_BONANZA',
    AC_FROM_MANY_DOTSAC_HTML_NONSENSE_TAGS: 'AC_FROM_MANY_DOTSAC_HTML_NONSENSE_TAGS',
    AC_POST_EXTRAS: 'AC_POST_EXTRAS',
    AC_SPAMMY_URI_PATTERNS1: 'AC_SPAMMY_URI_PATTERNS1',
    AC_SPAMMY_URI_PATTERNS10: 'AC_SPAMMY_URI_PATTERNS10',
    AC_SPAMMY_URI_PATTERNS11: 'AC_SPAMMY_URI_PATTERNS11',
    AC_SPAMMY_URI_PATTERNS12AC_SPAMMY_URI_PATTERNS2: 'AC_SPAMMY_URI_PATTERNS12AC_SPAMMY_URI_PATTERNS2',
    AC_SPAMMY_URI_PATTERNS3: 'AC_SPAMMY_URI_PATTERNS3',
    AC_SPAMMY_URI_PATTERNS4: 'AC_SPAMMY_URI_PATTERNS4',
    AC_SPAMMY_URI_PATTERNS8: 'AC_SPAMMY_URI_PATTERNS8',
    AC_SPAMMY_URI_PATTERNS9: 'AC_SPAMMY_URI_PATTERNS9',
    ADMAILADMITS_SPAM: 'ADMAILADMITS_SPAM',
    ADULT_DATING_COMPANY: 'ADULT_DATING_COMPANY',
    ADVANCE_FEE_2_NEW_FORM: 'ADVANCE_FEE_2_NEW_FORM',
    ADVANCE_FEE_2_NEW_FRM_MNY: 'ADVANCE_FEE_2_NEW_FRM_MNY',
    ADVANCE_FEE_2_NEW_MONEY: 'ADVANCE_FEE_2_NEW_MONEY',
    ADVANCE_FEE_3_NEWADVANCE_FEE_3_NEW_FORM: 'ADVANCE_FEE_3_NEWADVANCE_FEE_3_NEW_FORM',
    ADVANCE_FEE_3_NEW_FRM_MNY: 'ADVANCE_FEE_3_NEW_FRM_MNY',
    ADVANCE_FEE_3_NEW_MONEY: 'ADVANCE_FEE_3_NEW_MONEY',
    ADVANCE_FEE_4_NEW: 'ADVANCE_FEE_4_NEW',
    ADVANCE_FEE_4_NEW_FORM: 'ADVANCE_FEE_4_NEW_FORM',
    ADVANCE_FEE_4_NEW_FRM_MNYADVANCE_FEE_4_NEW_MONEY: 'ADVANCE_FEE_4_NEW_FRM_MNYADVANCE_FEE_4_NEW_MONEY',
    ADVANCE_FEE_5_NEW: 'ADVANCE_FEE_5_NEW',
    ADVANCE_FEE_5_NEW_FORM: 'ADVANCE_FEE_5_NEW_FORM',
    ADVANCE_FEE_5_NEW_FRM_MNY: 'ADVANCE_FEE_5_NEW_FRM_MNY',
    ADVANCE_FEE_5_NEW_MONEY: 'ADVANCE_FEE_5_NEW_MONEY',
    ADV_SUBJAD_COMPLAINTS: 'ADV_SUBJAD_COMPLAINTS',
    AD_PREFS: 'AD_PREFS',
    ALIBABA_IMG_NOT_RCVD_ALI: 'ALIBABA_IMG_NOT_RCVD_ALI',
    ALL_TRUSTED: 'ALL_TRUSTED',
    AMAZON_IMG_NOT_RCVD_AMZN: 'AMAZON_IMG_NOT_RCVD_AMZN',
    ANY_BOUNCE_MESSAGE: 'ANY_BOUNCE_MESSAGE',
    APOSTROPHE_FROM: 'APOSTROPHE_FROM',
    APP_DEVELOPMENT_FREEMAPP_DEVELOPMENT_NORDNS: 'APP_DEVELOPMENT_FREEMAPP_DEVELOPMENT_NORDNS',
    ARC_SIGNED: 'ARC_SIGNED',
    ARC_VALID: 'ARC_VALID',
    AXB_EMAILBL_FROMSRS: 'AXB_EMAILBL_FROMSRS',
    AXB_EMAILBL_OEMAIL: 'AXB_EMAILBL_OEMAIL',
    AXB_EMAILBL_YMMF: 'AXB_EMAILBL_YMMF',
    AXB_RAW_TXTRO: 'AXB_RAW_TXTRO',
    AXB_URI_MLW_DROPBOXAXB_XMAILER_MIMEOLE_OL_024C2: 'AXB_URI_MLW_DROPBOXAXB_XMAILER_MIMEOLE_OL_024C2',
    AXB_XM_FORGED_OL2600: 'AXB_XM_FORGED_OL2600',
    AXB_XM_LORIS232: 'AXB_XM_LORIS232',
    BAD_CREDIT: 'BAD_CREDIT',
    BAD_ENC_HEADER: 'BAD_ENC_HEADER',
    BANG_GUAR: 'BANG_GUAR',
    BANG_OPRAH: 'BANG_OPRAH',
    BANKING_LAWSBASE64_LENGTH_78_79: 'BANKING_LAWSBASE64_LENGTH_78_79',
    BASE64_LENGTH_79_INF: 'BASE64_LENGTH_79_INF',
    BAYES_00: 'BAYES_00',
    BAYES_05: 'BAYES_05',
    BAYES_20: 'BAYES_20',
    BAYES_40: 'BAYES_40',
    BAYES_50: 'BAYES_50',
    BAYES_60: 'BAYES_60',
    BAYES_80: 'BAYES_80',
    BAYES_95: 'BAYES_95',
    BAYES_99BAYES_999: 'BAYES_99BAYES_999',
    BBC_RCVD_NCHAR_RAW: 'BBC_RCVD_NCHAR_RAW',
    BEBEE_IMG_NOT_RCVD_BB: 'BEBEE_IMG_NOT_RCVD_BB',
    BELL_MOBILITY_TXT_MSG: 'BELL_MOBILITY_TXT_MSG',
    BIGNUM_EMAILS_FREEM: 'BIGNUM_EMAILS_FREEM',
    BIGNUM_EMAILS_MANY: 'BIGNUM_EMAILS_MANY',
    BILLION_DOLLARSBILLION_OVERLAP: 'BILLION_DOLLARSBILLION_OVERLAP',
    BILL_1618: 'BILL_1618',
    BITCOIN_BOMB: 'BITCOIN_BOMB',
    BITCOIN_DEADLINE: 'BITCOIN_DEADLINE',
    BITCOIN_EXTORT_01: 'BITCOIN_EXTORT_01',
    BITCOIN_EXTORT_02: 'BITCOIN_EXTORT_02',
    BITCOIN_IMGUR: 'BITCOIN_IMGUR',
    BITCOIN_MALWAREBITCOIN_OBFU_SUBJ: 'BITCOIN_MALWAREBITCOIN_OBFU_SUBJ',
    BITCOIN_ONAN: 'BITCOIN_ONAN',
    BITCOIN_PAY_ME: 'BITCOIN_PAY_ME',
    BITCOIN_SPAM_01: 'BITCOIN_SPAM_01',
    BITCOIN_SPAM_02: 'BITCOIN_SPAM_02',
    BITCOIN_SPAM_03: 'BITCOIN_SPAM_03',
    BITCOIN_SPAM_04: 'BITCOIN_SPAM_04',
    BITCOIN_SPAM_05BITCOIN_SPAM_06: 'BITCOIN_SPAM_05BITCOIN_SPAM_06',
    BITCOIN_SPAM_07: 'BITCOIN_SPAM_07',
    BITCOIN_SPAM_08: 'BITCOIN_SPAM_08',
    BITCOIN_SPAM_09: 'BITCOIN_SPAM_09',
    BITCOIN_SPAM_10: 'BITCOIN_SPAM_10',
    BITCOIN_SPAM_11: 'BITCOIN_SPAM_11',
    BITCOIN_SPAM_12: 'BITCOIN_SPAM_12',
    BITCOIN_SPF_ONLYALLBITCOIN_TOEQFM: 'BITCOIN_SPF_ONLYALLBITCOIN_TOEQFM',
    BITCOIN_VISTA: 'BITCOIN_VISTA',
    BITCOIN_WFH_01: 'BITCOIN_WFH_01',
    BITCOIN_XPRIO: 'BITCOIN_XPRIO',
    BITCOIN_YOUR_INFO: 'BITCOIN_YOUR_INFO',
    BLANK_LINES_80_90: 'BLANK_LINES_80_90',
    BODY_ENHANCEMENT: 'BODY_ENHANCEMENT',
    BODY_ENHANCEMENT2BODY_URI_ONLY: 'BODY_ENHANCEMENT2BODY_URI_ONLY',
    BOGUS_MIME_VERSION: 'BOGUS_MIME_VERSION',
    BOGUS_MSM_HDRS: 'BOGUS_MSM_HDRS',
    BOMB_FREEM: 'BOMB_FREEM',
    BOMB_MONEY: 'BOMB_MONEY',
    BOTNET_NOPLUGIN: 'BOTNET_NOPLUGIN',
    BOTNET_OCNNEJP: 'BOTNET_OCNNEJP',
    BOTNET_SHAWCABLE: 'BOTNET_SHAWCABLE',
    BOUNCE_MESSAGEBTC_ORG: 'BOUNCE_MESSAGEBTC_ORG',
    BUG6919_RDNS_DYNAMIC: 'BUG6919_RDNS_DYNAMIC',
    BUG6919_RDNS_GENERIC: 'BUG6919_RDNS_GENERIC',
    BULK_RE_SUSP_NTLD: 'BULK_RE_SUSP_NTLD',
    CALL_SKYPE: 'CALL_SKYPE',
    CANT_SEE_AD: 'CANT_SEE_AD',
    CAN_SPAM_HDR: 'CAN_SPAM_HDR',
    CARD_DIRECT_WWW_ADDRESSCDISP_SZ_MANY: 'CARD_DIRECT_WWW_ADDRESSCDISP_SZ_MANY',
    CHALLENGE_RESPONSE: 'CHALLENGE_RESPONSE',
    CHARSET_FARAWAY: 'CHARSET_FARAWAY',
    CHARSET_FARAWAY_HEADER: 'CHARSET_FARAWAY_HEADER',
    CHAR_PERIODS: 'CHAR_PERIODS',
    CN_B2B_SPAMMER: 'CN_B2B_SPAMMER',
    CN_OPTOUT_EML: 'CN_OPTOUT_EML',
    COMMENT_GIBBERISHCOMPENSATION: 'COMMENT_GIBBERISHCOMPENSATION',
    COMPUTERS_JEWELRY: 'COMPUTERS_JEWELRY',
    CONFIRMED_FORGED: 'CONFIRMED_FORGED',
    CONTENT_AFTER_HTML: 'CONTENT_AFTER_HTML',
    CONTENT_AFTER_HTML_WEAK: 'CONTENT_AFTER_HTML_WEAK',
    CORRUPT_FROM_LINE_IN_HDRS: 'CORRUPT_FROM_LINE_IN_HDRS',
    CRBOUNCE_MESSAGECTE_8BIT_MISMATCH: 'CRBOUNCE_MESSAGECTE_8BIT_MISMATCH',
    CTYPE_001C_A: 'CTYPE_001C_A',
    CTYPE_001C_B: 'CTYPE_001C_B',
    CTYPE_8SPACE_GIF: 'CTYPE_8SPACE_GIF',
    CUM_SHOT: 'CUM_SHOT',
    CURR_PRICE: 'CURR_PRICE',
    DATE_DOTS: 'DATE_DOTS',
    DATE_IN_FUTURE_03_06: 'DATE_IN_FUTURE_03_06',
    DATE_IN_FUTURE_06_12DATE_IN_FUTURE_12_24: 'DATE_IN_FUTURE_06_12DATE_IN_FUTURE_12_24',
    DATE_IN_FUTURE_24_48: 'DATE_IN_FUTURE_24_48',
    DATE_IN_FUTURE_48_96: 'DATE_IN_FUTURE_48_96',
    DATE_IN_FUTURE_96_Q: 'DATE_IN_FUTURE_96_Q',
    DATE_IN_FUTURE_96_XX: 'DATE_IN_FUTURE_96_XX',
    DATE_IN_FUTURE_Q_PLUSDATE_IN_PAST_03_06: 'DATE_IN_FUTURE_Q_PLUSDATE_IN_PAST_03_06',
    DATE_IN_PAST_06_12: 'DATE_IN_PAST_06_12',
    DATE_IN_PAST_12_24: 'DATE_IN_PAST_12_24',
    DATE_IN_PAST_24_48: 'DATE_IN_PAST_24_48',
    DATE_IN_PAST_96_XX: 'DATE_IN_PAST_96_XX',
    DATE_SPAMWARE_Y2K: 'DATE_SPAMWARE_Y2K',
    DAY_I_EARNEDDC_GIF_UNO_LARGO: 'DAY_I_EARNEDDC_GIF_UNO_LARGO',
    DC_IMAGE_SPAM_HTML: 'DC_IMAGE_SPAM_HTML',
    DC_IMAGE_SPAM_TEXT: 'DC_IMAGE_SPAM_TEXT',
    DC_PNG_UNO_LARGO: 'DC_PNG_UNO_LARGO',
    DEAR_BENEFICIARY: 'DEAR_BENEFICIARY',
    DEAR_EMAIL: 'DEAR_EMAIL',
    DEAR_EMAIL_USER: 'DEAR_EMAIL_USER',
    DEAR_FRIENDDEAR_NOBODY: 'DEAR_FRIENDDEAR_NOBODY',
    DEAR_SOMETHING: 'DEAR_SOMETHING',
    DEAR_WINNER: 'DEAR_WINNER',
    DG_SPAMMER_EMAIL_B: 'DG_SPAMMER_EMAIL_B',
    DG_SPAMMER_EMAIL_F: 'DG_SPAMMER_EMAIL_F',
    DIET_1: 'DIET_1',
    DIGEST_MULTIPLE: 'DIGEST_MULTIPLE',
    DKIMDOMAIN_IN_DWL: 'DKIMDOMAIN_IN_DWL',
    DKIMDOMAIN_IN_DWL_UNKNOWNDKIMWL_BL: 'DKIMDOMAIN_IN_DWL_UNKNOWNDKIMWL_BL',
    DKIMWL_BLOCKED: 'DKIMWL_BLOCKED',
    DKIMWL_WL_HIGH: 'DKIMWL_WL_HIGH',
    DKIMWL_WL_MED: 'DKIMWL_WL_MED',
    DKIMWL_WL_MEDHI: 'DKIMWL_WL_MEDHI',
    DKIM_ADSP_ALL: 'DKIM_ADSP_ALL',
    DKIM_ADSP_CUSTOM_HIGH: 'DKIM_ADSP_CUSTOM_HIGH',
    DKIM_ADSP_CUSTOM_LOWDKIM_ADSP_CUSTOM_MED: 'DKIM_ADSP_CUSTOM_LOWDKIM_ADSP_CUSTOM_MED',
    DKIM_ADSP_DISCARD: 'DKIM_ADSP_DISCARD',
    DKIM_ADSP_NXDOMAIN: 'DKIM_ADSP_NXDOMAIN',
    DKIM_INVALID: 'DKIM_INVALID',
    DKIM_POLICY_SIGNALL: 'DKIM_POLICY_SIGNALL',
    DKIM_POLICY_SIGNSOME: 'DKIM_POLICY_SIGNSOME',
    DKIM_POLICY_TESTINGDKIM_SIGNED: 'DKIM_POLICY_TESTINGDKIM_SIGNED',
    DKIM_VALID: 'DKIM_VALID',
    DKIM_VALID_AU: 'DKIM_VALID_AU',
    DKIM_VALID_EF: 'DKIM_VALID_EF',
    DKIM_VERIFIED: 'DKIM_VERIFIED',
    DNS_FROM_AHBL_RHSBL: 'DNS_FROM_AHBL_RHSBL',
    DOC_ATTACH_NO_EXT: 'DOC_ATTACH_NO_EXT',
    DOMAIN_UPPERCASE: 'DOMAIN_UPPERCASE',
    DOS_ANAL_SPAM_MAILERDOS_ANAL_SPAM_MAILER2: 'DOS_ANAL_SPAM_MAILERDOS_ANAL_SPAM_MAILER2',
    DOS_BODY_HIGH_NO_MID: 'DOS_BODY_HIGH_NO_MID',
    DOS_DEREK_AUG08: 'DOS_DEREK_AUG08',
    DOS_DOM_LIST_CENTER: 'DOS_DOM_LIST_CENTER',
    DOS_DOT_COM_AT: 'DOS_DOT_COM_AT',
    DOS_DOUBLE_SOTCK: 'DOS_DOUBLE_SOTCK',
    DOS_FAKE_UPS_TRACK_NUMDOS_FIX_MY_URI: 'DOS_FAKE_UPS_TRACK_NUMDOS_FIX_MY_URI',
    DOS_FORGED_RCVD_QUADS: 'DOS_FORGED_RCVD_QUADS',
    DOS_GOOGLE_LUCKY_REDIRECT: 'DOS_GOOGLE_LUCKY_REDIRECT',
    DOS_HC_ZIP_VIRUS: 'DOS_HC_ZIP_VIRUS',
    DOS_HIGH_BAT_TO_MX: 'DOS_HIGH_BAT_TO_MX',
    DOS_LET_GO_JOB: 'DOS_LET_GO_JOB',
    DOS_OE_TO_MXDOS_OE_TO_MX_IMAGE: 'DOS_OE_TO_MXDOS_OE_TO_MX_IMAGE',
    DOS_OUTLOOK_TO_MX: 'DOS_OUTLOOK_TO_MX',
    DOS_OUTLOOK_TO_MX_IMAGE: 'DOS_OUTLOOK_TO_MX_IMAGE',
    DOS_PLAYED_IN_HARDCORE: 'DOS_PLAYED_IN_HARDCORE',
    DOS_PORN_BOUNDARY: 'DOS_PORN_BOUNDARY',
    DOS_PROVISION4: 'DOS_PROVISION4',
    DOS_RCVD_IP_TWICE_ADOS_RCVD_IP_TWICE_B: 'DOS_RCVD_IP_TWICE_ADOS_RCVD_IP_TWICE_B',
    DOS_RCVD_IP_TWICE_C: 'DOS_RCVD_IP_TWICE_C',
    DOS_REMOVE_DOMAIN_DOT: 'DOS_REMOVE_DOMAIN_DOT',
    DOS_REMOVE_DOMAIN_DOT_YAHOO: 'DOS_REMOVE_DOMAIN_DOT_YAHOO',
    DOS_REPORT_FIN_INC: 'DOS_REPORT_FIN_INC',
    DOS_STOCK_BATDOS_STOCK_BAT2: 'DOS_STOCK_BATDOS_STOCK_BAT2',
    DOS_STOCK_CDYV_GENERIC: 'DOS_STOCK_CDYV_GENERIC',
    DOS_STOCK_INCOME_STATEMENT: 'DOS_STOCK_INCOME_STATEMENT',
    DOS_STOCK_O_PRICE: 'DOS_STOCK_O_PRICE',
    DOS_TO_READ_STOCK: 'DOS_TO_READ_STOCK',
    DOS_TWO_MIS_STOCK: 'DOS_TWO_MIS_STOCK',
    DOS_URI_ASTERISKDOS_YOUR_PLACE: 'DOS_URI_ASTERISKDOS_YOUR_PLACE',
    DOS_ZIP_HARDCORE: 'DOS_ZIP_HARDCORE',
    DOTGOV_IMAGE: 'DOTGOV_IMAGE',
    DP_PHPMAILER: 'DP_PHPMAILER',
    DQ_URI_DOM_IN_PATH: 'DQ_URI_DOM_IN_PATH',
    DRUGS_ANXIETY: 'DRUGS_ANXIETY',
    DRUGS_ANXIETY_EREC: 'DRUGS_ANXIETY_EREC',
    DRUGS_ANXIETY_OBFUDRUGS_DIET: 'DRUGS_ANXIETY_OBFUDRUGS_DIET',
    DRUGS_DIET_OBFU: 'DRUGS_DIET_OBFU',
    DRUGS_ERECTILE: 'DRUGS_ERECTILE',
    DRUGS_ERECTILE_OBFU: 'DRUGS_ERECTILE_OBFU',
    DRUGS_HDIA: 'DRUGS_HDIA',
    DRUGS_MANYKINDS: 'DRUGS_MANYKINDS',
    DRUGS_MUSCLE: 'DRUGS_MUSCLE',
    DRUGS_SLEEP_EREC: 'DRUGS_SLEEP_EREC',
    DRUGS_SMEAR1DRUGS_STOCK_MIMEOLE: 'DRUGS_SMEAR1DRUGS_STOCK_MIMEOLE',
    DRUG_DOSAGE: 'DRUG_DOSAGE',
    DRUG_ED_CAPS: 'DRUG_ED_CAPS',
    DRUG_ED_GENERIC: 'DRUG_ED_GENERIC',
    DRUG_ED_ONLINE: 'DRUG_ED_ONLINE',
    DRUG_ED_SILD: 'DRUG_ED_SILD',
    DSN_NO_MIMEVERSION: 'DSN_NO_MIMEVERSION',
    DUH_DIKSBJ: 'DUH_DIKSBJ',
    DVLABS_GOZI_PDFDX_TEXT_02: 'DVLABS_GOZI_PDFDX_TEXT_02',
    DX_TEXT_03: 'DX_TEXT_03',
    DX_TEXT_04: 'DX_TEXT_04',
    DX_TEXT_05: 'DX_TEXT_05',
    DYNAMIC_IMGUR: 'DYNAMIC_IMGUR',
    DYN_RDNS_AND_INLINE_IMAGE: 'DYN_RDNS_AND_INLINE_IMAGE',
    DYN_RDNS_SHORT_HELO_HTML: 'DYN_RDNS_SHORT_HELO_HTML',
    DYN_RDNS_SHORT_HELO_IMAGEEBAY_IMG_NOT_RCVD_EBAY: 'DYN_RDNS_SHORT_HELO_IMAGEEBAY_IMG_NOT_RCVD_EBAY',
    EMAIL_ROT13: 'EMAIL_ROT13',
    EMPTY_MESSAGE: 'EMPTY_MESSAGE',
    EMPTY_RVW_ATTCH: 'EMPTY_RVW_ATTCH',
    EMRCP: 'EMRCP',
    EM_ROLEX: 'EM_ROLEX',
    ENA_SUBJ_IS_SPACE: 'ENA_SUBJ_IS_SPACE',
    ENA_SUBJ_ONLY_SPACES: 'ENA_SUBJ_ONLY_SPACES',
    ENCRYPTED_MESSAGEEND_FUTURE_EMAILS: 'ENCRYPTED_MESSAGEEND_FUTURE_EMAILS',
    ENGLISH_UCE_SUBJECT: 'ENGLISH_UCE_SUBJECT',
    ENVFROM_GOOG_TRIX: 'ENVFROM_GOOG_TRIX',
    ENV_AND_HDR_SPF_MATCH: 'ENV_AND_HDR_SPF_MATCH',
    ES_LIC_FROM_INFO: 'ES_LIC_FROM_INFO',
    EXCUSE_24: 'EXCUSE_24',
    EXCUSE_4: 'EXCUSE_4',
    EXCUSE_REMOVEEXECUTABLE_URI: 'EXCUSE_REMOVEEXECUTABLE_URI',
    FACEBOOK_IMG_NOT_RCVD_FB: 'FACEBOOK_IMG_NOT_RCVD_FB',
    FAKE_OUTBLAZE_RCVD: 'FAKE_OUTBLAZE_RCVD',
    FAKE_REPLY_C: 'FAKE_REPLY_C',
    FAKE_REPLY_SURE_B: 'FAKE_REPLY_SURE_B',
    FBI_MONEY: 'FBI_MONEY',
    FBI_SPOOF: 'FBI_SPOOF',
    FH_DATE_PAST_20XXFH_FROM_CASH: 'FH_DATE_PAST_20XXFH_FROM_CASH',
    FILL_THIS_FORM: 'FILL_THIS_FORM',
    FILL_THIS_FORM_FRAUD_PHISH: 'FILL_THIS_FORM_FRAUD_PHISH',
    FILL_THIS_FORM_LOAN: 'FILL_THIS_FORM_LOAN',
    FILL_THIS_FORM_LONG: 'FILL_THIS_FORM_LONG',
    FILL_THIS_FORM_SHORT: 'FILL_THIS_FORM_SHORT',
    FIN_FREEFONT_INVIS_DIRECT: 'FIN_FREEFONT_INVIS_DIRECT',
    FONT_INVIS_DOTGOV: 'FONT_INVIS_DOTGOV',
    FONT_INVIS_HTML_NOHTML: 'FONT_INVIS_HTML_NOHTML',
    FONT_INVIS_LONG_LINE: 'FONT_INVIS_LONG_LINE',
    FONT_INVIS_MSGID: 'FONT_INVIS_MSGID',
    FONT_INVIS_NORDNS: 'FONT_INVIS_NORDNS',
    FONT_INVIS_POSTEXTRASFORGED_GMAIL_RCVD: 'FONT_INVIS_POSTEXTRASFORGED_GMAIL_RCVD',
    FORGED_HOTMAIL_RCVD2: 'FORGED_HOTMAIL_RCVD2',
    FORGED_IMS_HTML: 'FORGED_IMS_HTML',
    FORGED_IMS_TAGS: 'FORGED_IMS_TAGS',
    FORGED_MSGID_AOL: 'FORGED_MSGID_AOL',
    FORGED_MSGID_EXCITE: 'FORGED_MSGID_EXCITE',
    FORGED_MSGID_HOTMAILFORGED_MSGID_MSN: 'FORGED_MSGID_HOTMAILFORGED_MSGID_MSN',
    FORGED_MSGID_YAHOO: 'FORGED_MSGID_YAHOO',
    FORGED_MUA_EUDORA: 'FORGED_MUA_EUDORA',
    FORGED_MUA_IMS: 'FORGED_MUA_IMS',
    FORGED_MUA_MOZILLA: 'FORGED_MUA_MOZILLA',
    FORGED_MUA_OIMO: 'FORGED_MUA_OIMO',
    FORGED_MUA_OUTLOOKFORGED_MUA_THEBAT_BOUN: 'FORGED_MUA_OUTLOOKFORGED_MUA_THEBAT_BOUN',
    FORGED_MUA_THEBAT_CS: 'FORGED_MUA_THEBAT_CS',
    FORGED_OUTLOOK_HTML: 'FORGED_OUTLOOK_HTML',
    FORGED_OUTLOOK_TAGS: 'FORGED_OUTLOOK_TAGS',
    FORGED_QUALCOMM_TAGS: 'FORGED_QUALCOMM_TAGS',
    FORGED_SPF_HELOFORGED_TBIRD_IMG_ARROW: 'FORGED_SPF_HELOFORGED_TBIRD_IMG_ARROW',
    FORGED_TBIRD_IMG_SIZE: 'FORGED_TBIRD_IMG_SIZE',
    FORGED_TBIRD_IMG_TO_MX: 'FORGED_TBIRD_IMG_TO_MX',
    FORGED_TELESP_RCVD: 'FORGED_TELESP_RCVD',
    FORGED_THEBAT_HTML: 'FORGED_THEBAT_HTML',
    FORGED_URL_DOMFORGED_YAHOO_RCVD: 'FORGED_URL_DOMFORGED_YAHOO_RCVD',
    FORM_FRAUD: 'FORM_FRAUD',
    FORM_FRAUD_3: 'FORM_FRAUD_3',
    FORM_FRAUD_5: 'FORM_FRAUD_5',
    FORM_LOW_CONTRAST: 'FORM_LOW_CONTRAST',
    FORWARD_LOOKING: 'FORWARD_LOOKING',
    FOUND_YOU: 'FOUND_YOU',
    FRAGMENTED_MESSAGE: 'FRAGMENTED_MESSAGE',
    FREEMAIL_DOC_PDFFREEMAIL_DOC_PDF_BCC: 'FREEMAIL_DOC_PDFFREEMAIL_DOC_PDF_BCC',
    FREEMAIL_ENVFROM_END_DIGIT: 'FREEMAIL_ENVFROM_END_DIGIT',
    FREEMAIL_FORGED_FROMDOMAIN: 'FREEMAIL_FORGED_FROMDOMAIN',
    FREEMAIL_FORGED_REPLYTO: 'FREEMAIL_FORGED_REPLYTO',
    FREEMAIL_FROM: 'FREEMAIL_FROM',
    FREEMAIL_MANY_TOFREEMAIL_REPLY: 'FREEMAIL_MANY_TOFREEMAIL_REPLY',
    FREEMAIL_REPLYTO: 'FREEMAIL_REPLYTO',
    FREEMAIL_REPLYTO_END_DIGIT: 'FREEMAIL_REPLYTO_END_DIGIT',
    FREEMAIL_RVW_ATTCH: 'FREEMAIL_RVW_ATTCH',
    FREEMAIL_WFH_01: 'FREEMAIL_WFH_01',
    FREEM_FRNUM_UNICD_EMPTY: 'FREEM_FRNUM_UNICD_EMPTY',
    FREE_PORNFREE_QUOTE_INSTANT: 'FREE_PORNFREE_QUOTE_INSTANT',
    FRNAME_IN_MSG_XPRIO_NO_SUB: 'FRNAME_IN_MSG_XPRIO_NO_SUB',
    FROMSPACE: 'FROMSPACE',
    FROM_2_EMAILS: 'FROM_2_EMAILS',
    FROM_ADDR_BCDE: 'FROM_ADDR_BCDE',
    FROM_ADDR_WS: 'FROM_ADDR_WS',
    FROM_BANK_NOAUTH: 'FROM_BANK_NOAUTH',
    FROM_BLANK_NAMEFROM_DOMAIN_NOVOWEL: 'FROM_BLANK_NAMEFROM_DOMAIN_NOVOWEL',
    FROM_EXCESS_BASE64: 'FROM_EXCESS_BASE64',
    FROM_FMBLA_NDBLOCKED: 'FROM_FMBLA_NDBLOCKED',
    FROM_FMBLA_NEWDOM: 'FROM_FMBLA_NEWDOM',
    FROM_FMBLA_NEWDOM14: 'FROM_FMBLA_NEWDOM14',
    FROM_FMBLA_NEWDOM28: 'FROM_FMBLA_NEWDOM28',
    FROM_GOV_DKIM_AUFROM_GOV_REPLYTO_FREEMAIL: 'FROM_GOV_DKIM_AUFROM_GOV_REPLYTO_FREEMAIL',
    FROM_GOV_SPOOF: 'FROM_GOV_SPOOF',
    FROM_ILLEGAL_CHARS: 'FROM_ILLEGAL_CHARS',
    FROM_IN_TO_AND_SUBJ: 'FROM_IN_TO_AND_SUBJ',
    FROM_LOCAL_DIGITS: 'FROM_LOCAL_DIGITS',
    FROM_LOCAL_HEX: 'FROM_LOCAL_HEX',
    FROM_LOCAL_NOVOWELFROM_LONG_DOM: 'FROM_LOCAL_NOVOWELFROM_LONG_DOM',
    FROM_LONG_DOM_MINFP: 'FROM_LONG_DOM_MINFP',
    FROM_LOWER_UPPER: 'FROM_LOWER_UPPER',
    FROM_MISSPACED: 'FROM_MISSPACED',
    FROM_MISSP_EH_MATCH: 'FROM_MISSP_EH_MATCH',
    FROM_MISSP_FREEMAIL: 'FROM_MISSP_FREEMAIL',
    FROM_MISSP_MSFTFROM_MISSP_PHISH: 'FROM_MISSP_MSFTFROM_MISSP_PHISH',
    FROM_MISSP_REPLYTO: 'FROM_MISSP_REPLYTO',
    FROM_MISSP_SPF_FAIL: 'FROM_MISSP_SPF_FAIL',
    FROM_MISSP_USER: 'FROM_MISSP_USER',
    FROM_MISSP_XPRIO: 'FROM_MISSP_XPRIO',
    FROM_MULTI_NORDNS: 'FROM_MULTI_NORDNS',
    FROM_NEWDOM_BTCFROM_NO_USER: 'FROM_NEWDOM_BTCFROM_NO_USER',
    FROM_NTLD_LINKBAIT: 'FROM_NTLD_LINKBAIT',
    FROM_NTLD_REPLY_FREEMAIL: 'FROM_NTLD_REPLY_FREEMAIL',
    FROM_NUMBERO_NEWDOMAIN: 'FROM_NUMBERO_NEWDOMAIN',
    FROM_NUMBERS: 'FROM_NUMBERS',
    FROM_OFFERS: 'FROM_OFFERS',
    FROM_ONE_CHAR: 'FROM_ONE_CHAR',
    FROM_PAYPAL_SPOOFFROM_PERCENT: 'FROM_PAYPAL_SPOOFFROM_PERCENT',
    FROM_PUNCTUATION: 'FROM_PUNCTUATION',
    FROM_SPACE_COMMA: 'FROM_SPACE_COMMA',
    FROM_SPLAT: 'FROM_SPLAT',
    FROM_STARTS_WITH_NUMS: 'FROM_STARTS_WITH_NUMS',
    FROM_SUSPICIOUS_NTLD: 'FROM_SUSPICIOUS_NTLD',
    FROM_SUSPICIOUS_NTLD_FPFROM_UNBAL2: 'FROM_SUSPICIOUS_NTLD_FPFROM_UNBAL2',
    FROM_UPPER_LOWER: 'FROM_UPPER_LOWER',
    FROM_URI: 'FROM_URI',
    FROM_WEBSITE: 'FROM_WEBSITE',
    FROM_WWW: 'FROM_WWW',
    FSL_ABUSED_WEB_1: 'FSL_ABUSED_WEB_1',
    FSL_ABUSED_WEB_2: 'FSL_ABUSED_WEB_2',
    FSL_ABUSED_WEB_3: 'FSL_ABUSED_WEB_3',
    FSL_BOTSPAM_1FSL_BULK_SIG: 'FSL_BOTSPAM_1FSL_BULK_SIG',
    FSL_CTYPE_WIN1251: 'FSL_CTYPE_WIN1251',
    FSL_FAKE_HOTMAIL_RVCD: 'FSL_FAKE_HOTMAIL_RVCD',
    FSL_HELO_BARE_IP_1: 'FSL_HELO_BARE_IP_1',
    FSL_HELO_BARE_IP_2: 'FSL_HELO_BARE_IP_2',
    FSL_HELO_DEVICE: 'FSL_HELO_DEVICE',
    FSL_HELO_FIREWALLFSL_HELO_NON_FQDN_1: 'FSL_HELO_FIREWALLFSL_HELO_NON_FQDN_1',
    FSL_HELO_SETUP: 'FSL_HELO_SETUP',
    FSL_HTML_BLOCK_LOTS_1: 'FSL_HTML_BLOCK_LOTS_1',
    FSL_HTML_BLOCK_LOTS_2: 'FSL_HTML_BLOCK_LOTS_2',
    FSL_HTML_BLOCK_LOTS_3: 'FSL_HTML_BLOCK_LOTS_3',
    FSL_HTML_ENT_LOTS_1FSL_HTML_ENT_LOTS_2: 'FSL_HTML_ENT_LOTS_1FSL_HTML_ENT_LOTS_2',
    FSL_HTML_ENT_LOTS_3: 'FSL_HTML_ENT_LOTS_3',
    FSL_INTERIA_ABUSE: 'FSL_INTERIA_ABUSE',
    FSL_LINK_AWS_S3_WEB: 'FSL_LINK_AWS_S3_WEB',
    FSL_LINK_AWS_S3_WEB_FM: 'FSL_LINK_AWS_S3_WEB_FM',
    FSL_MID_419: 'FSL_MID_419',
    FSL_MIME_NO_TEXTFSL_NEW_HELO_USER: 'FSL_MIME_NO_TEXTFSL_NEW_HELO_USER',
    FSL_NOT_FROM_AOL: 'FSL_NOT_FROM_AOL',
    FSL_NOT_FROM_GOOGLE: 'FSL_NOT_FROM_GOOGLE',
    FSL_NOT_FROM_HOTMAIL: 'FSL_NOT_FROM_HOTMAIL',
    FSL_NOT_FROM_YAHOO: 'FSL_NOT_FROM_YAHOO',
    FSL_NO_RCVD_1: 'FSL_NO_RCVD_1',
    FSL_PHP_EXPLOIT_41FSL_RCVD_EX_0: 'FSL_PHP_EXPLOIT_41FSL_RCVD_EX_0',
    FSL_RCVD_EX_1: 'FSL_RCVD_EX_1',
    FSL_RCVD_EX_2: 'FSL_RCVD_EX_2',
    FSL_RCVD_EX_3: 'FSL_RCVD_EX_3',
    FSL_RCVD_EX_4: 'FSL_RCVD_EX_4',
    FSL_RCVD_EX_5: 'FSL_RCVD_EX_5',
    FSL_RCVD_EX_GT_5: 'FSL_RCVD_EX_GT_5',
    FSL_RCVD_TR_1: 'FSL_RCVD_TR_1',
    FSL_RCVD_TR_2FSL_RCVD_TR_3: 'FSL_RCVD_TR_2FSL_RCVD_TR_3',
    FSL_RCVD_TR_4: 'FSL_RCVD_TR_4',
    FSL_RCVD_TR_5: 'FSL_RCVD_TR_5',
    FSL_RCVD_TR_GT_5: 'FSL_RCVD_TR_GT_5',
    FSL_RCVD_UT_1: 'FSL_RCVD_UT_1',
    FSL_RCVD_UT_2: 'FSL_RCVD_UT_2',
    FSL_RCVD_UT_3: 'FSL_RCVD_UT_3',
    FSL_RCVD_UT_4: 'FSL_RCVD_UT_4',
    FSL_RCVD_UT_5FSL_RCVD_UT_GT_5: 'FSL_RCVD_UT_5FSL_RCVD_UT_GT_5',
    FSL_STACKED_TEXT: 'FSL_STACKED_TEXT',
    FSL_THIS_IS_ADV: 'FSL_THIS_IS_ADV',
    FSL_UNDISCLOSED_BULK: 'FSL_UNDISCLOSED_BULK',
    FSL_UNDISCLOSED_RCPTS: 'FSL_UNDISCLOSED_RCPTS',
    FSL_YAHOO_AUTH_SIG: 'FSL_YAHOO_AUTH_SIG',
    FSL_YHG_ABUSEFUZZY_AFFORDABLE: 'FSL_YHG_ABUSEFUZZY_AFFORDABLE',
    FUZZY_AMAZON: 'FUZZY_AMAZON',
    FUZZY_ANDROID: 'FUZZY_ANDROID',
    FUZZY_APPLE: 'FUZZY_APPLE',
    FUZZY_BILLION: 'FUZZY_BILLION',
    FUZZY_BITCOIN: 'FUZZY_BITCOIN',
    FUZZY_BROWSER: 'FUZZY_BROWSER',
    FUZZY_BTC_WALLET: 'FUZZY_BTC_WALLET',
    FUZZY_CLICK_HEREFUZZY_CPILL: 'FUZZY_CLICK_HEREFUZZY_CPILL',
    FUZZY_CREDIT: 'FUZZY_CREDIT',
    FUZZY_DR_OZ: 'FUZZY_DR_OZ',
    FUZZY_FACEBOOK: 'FUZZY_FACEBOOK',
    FUZZY_GUARANTEE: 'FUZZY_GUARANTEE',
    FUZZY_HARRIS: 'FUZZY_HARRIS',
    FUZZY_IMPORTANT: 'FUZZY_IMPORTANT',
    FUZZY_MEDICATION: 'FUZZY_MEDICATION',
    FUZZY_MERIDIAFUZZY_MICROSOFT: 'FUZZY_MERIDIAFUZZY_MICROSOFT',
    FUZZY_MILLION: 'FUZZY_MILLION',
    FUZZY_MONERO: 'FUZZY_MONERO',
    FUZZY_MONEY: 'FUZZY_MONEY',
    FUZZY_MORTGAGE: 'FUZZY_MORTGAGE',
    FUZZY_NORTON: 'FUZZY_NORTON',
    FUZZY_OBLIGATION: 'FUZZY_OBLIGATION',
    FUZZY_OFFERS: 'FUZZY_OFFERS',
    FUZZY_OPTOUTFUZZY_OVERSTOCK: 'FUZZY_OPTOUTFUZZY_OVERSTOCK',
    FUZZY_PAYPAL: 'FUZZY_PAYPAL',
    FUZZY_PHARMACY: 'FUZZY_PHARMACY',
    FUZZY_PHENT: 'FUZZY_PHENT',
    FUZZY_PORN: 'FUZZY_PORN',
    FUZZY_PRESCRIPT: 'FUZZY_PRESCRIPT',
    FUZZY_PRICES: 'FUZZY_PRICES',
    FUZZY_PRIVACY: 'FUZZY_PRIVACY',
    FUZZY_PROMOTIONFUZZY_REFINANCE: 'FUZZY_PROMOTIONFUZZY_REFINANCE',
    FUZZY_REMOVE: 'FUZZY_REMOVE',
    FUZZY_SAVINGS: 'FUZZY_SAVINGS',
    FUZZY_SECURITY: 'FUZZY_SECURITY',
    FUZZY_SOFTWARE: 'FUZZY_SOFTWARE',
    FUZZY_THOUSANDS: 'FUZZY_THOUSANDS',
    FUZZY_TRUMP: 'FUZZY_TRUMP',
    FUZZY_TRUSTWALLET: 'FUZZY_TRUSTWALLET',
    FUZZY_UNSUBSCRIBEFUZZY_VIOXX: 'FUZZY_UNSUBSCRIBEFUZZY_VIOXX',
    FUZZY_VLIUM: 'FUZZY_VLIUM',
    FUZZY_VPILL: 'FUZZY_VPILL',
    FUZZY_WALLET: 'FUZZY_WALLET',
    FUZZY_WELLSFARGO: 'FUZZY_WELLSFARGO',
    FUZZY_XPILL: 'FUZZY_XPILL',
    GAPPY_GENITALIA: 'GAPPY_GENITALIA',
    GAPPY_HTML: 'GAPPY_HTML',
    GAPPY_LOW_CONTRASTGAPPY_PHONE_NA: 'GAPPY_LOW_CONTRASTGAPPY_PHONE_NA',
    GAPPY_PILLS: 'GAPPY_PILLS',
    GAPPY_SALES_LEADS_FREEM: 'GAPPY_SALES_LEADS_FREEM',
    GAPPY_SUBJECT: 'GAPPY_SUBJECT',
    GB_BITCOIN_NH: 'GB_BITCOIN_NH',
    GB_CUSTOM_HTM_URI: 'GB_CUSTOM_HTM_URI',
    GB_FAKE_RF_SHORT: 'GB_FAKE_RF_SHORT',
    GB_FORGED_MUA_POSTFIXGB_FREEMAIL_DISPTO: 'GB_FORGED_MUA_POSTFIXGB_FREEMAIL_DISPTO',
    GB_FREEMAIL_DISPTO_NOTFREEM: 'GB_FREEMAIL_DISPTO_NOTFREEM',
    GB_GOOGLE_OBFUR: 'GB_GOOGLE_OBFUR',
    GB_HASHBL_BTC: 'GB_HASHBL_BTC',
    GB_LINKED_IMG_NOT_RCVD_LINK: 'GB_LINKED_IMG_NOT_RCVD_LINK',
    GB_STORAGE_GOOGLE_EMAILGB_WETRANSFER_HTM: 'GB_STORAGE_GOOGLE_EMAILGB_WETRANSFER_HTM',
    GEO_QUERY_STRING: 'GEO_QUERY_STRING',
    GERMANSPAM: 'GERMANSPAM',
    GMD_PRODUCER_POWERPDF: 'GMD_PRODUCER_POWERPDF',
    GOOGLE_DOCS_PHISH: 'GOOGLE_DOCS_PHISH',
    GOOGLE_DOCS_PHISH_MANY: 'GOOGLE_DOCS_PHISH_MANY',
    GOOGLE_DOC_SUSPGOOGLE_DRIVE_REPLY_BAD_NTLD: 'GOOGLE_DOC_SUSPGOOGLE_DRIVE_REPLY_BAD_NTLD',
    GOOG_MALWARE_DNLD: 'GOOG_MALWARE_DNLD',
    GOOG_REDIR_DOCUSIGN: 'GOOG_REDIR_DOCUSIGN',
    GOOG_REDIR_HTML_ONLY: 'GOOG_REDIR_HTML_ONLY',
    GOOG_REDIR_NORDNS: 'GOOG_REDIR_NORDNS',
    GOOG_REDIR_SHORTGOOG_STO_EMAIL_PHISH: 'GOOG_REDIR_SHORTGOOG_STO_EMAIL_PHISH',
    GOOG_STO_HTML_PHISH: 'GOOG_STO_HTML_PHISH',
    GOOG_STO_HTML_PHISH_MANY: 'GOOG_STO_HTML_PHISH_MANY',
    GOOG_STO_IMG_HTML: 'GOOG_STO_IMG_HTML',
    GOOG_STO_IMG_NOHTML: 'GOOG_STO_IMG_NOHTML',
    GOOG_STO_NOIMG_HTMLGTUBE: 'GOOG_STO_NOIMG_HTMLGTUBE',
    GUARANTEED_100_PERCENT: 'GUARANTEED_100_PERCENT',
    HACKED_PHP_URI: 'HACKED_PHP_URI',
    HASHCASH_20: 'HASHCASH_20',
    HASHCASH_21: 'HASHCASH_21',
    HASHCASH_22: 'HASHCASH_22',
    HASHCASH_23: 'HASHCASH_23',
    HASHCASH_24: 'HASHCASH_24',
    HASHCASH_25: 'HASHCASH_25',
    HASHCASH_2SPENDHASHCASH_HIGH: 'HASHCASH_2SPENDHASHCASH_HIGH',
    HAS_APPARENTLY_TO: 'HAS_APPARENTLY_TO',
    HAS_X_NO_RELAY: 'HAS_X_NO_RELAY',
    HAS_X_OUTGOING_SPAM_STAT: 'HAS_X_OUTGOING_SPAM_STAT',
    HDRS_LCASE: 'HDRS_LCASE',
    HDRS_LCASE_IMGONLY: 'HDRS_LCASE_IMGONLY',
    HDRS_MISSP: 'HDRS_MISSP',
    HDR_CASE_REV_ENCHDR_CASE_REV_HELO_IP: 'HDR_CASE_REV_ENCHDR_CASE_REV_HELO_IP',
    HDR_CASE_REV_MANY: 'HDR_CASE_REV_MANY',
    HDR_ORDER_FTSDMCXX_001C: 'HDR_ORDER_FTSDMCXX_001C',
    HDR_ORDER_FTSDMCXX_BAT: 'HDR_ORDER_FTSDMCXX_BAT',
    HDR_ORDER_FTSDMCXX_DIRECT: 'HDR_ORDER_FTSDMCXX_DIRECT',
    HDR_ORDER_FTSDMCXX_NORDNSHEADER_COUNT_CTYPE: 'HDR_ORDER_FTSDMCXX_NORDNSHEADER_COUNT_CTYPE',
    HEADER_COUNT_SUBJECT: 'HEADER_COUNT_SUBJECT',
    HEADER_FROM_DIFFERENT_DOMAINS: 'HEADER_FROM_DIFFERENT_DOMAINS',
    HEADER_SPAM: 'HEADER_SPAM',
    HEAD_ILLEGAL_CHARS: 'HEAD_ILLEGAL_CHARS',
    HEAD_LONG: 'HEAD_LONG',
    HELO_DYNAMIC_CHELLO_NLHELO_DYNAMIC_DHCP: 'HELO_DYNAMIC_CHELLO_NLHELO_DYNAMIC_DHCP',
    HELO_DYNAMIC_DIALIN: 'HELO_DYNAMIC_DIALIN',
    HELO_DYNAMIC_HCC: 'HELO_DYNAMIC_HCC',
    HELO_DYNAMIC_HEXIP: 'HELO_DYNAMIC_HEXIP',
    HELO_DYNAMIC_HOME_NL: 'HELO_DYNAMIC_HOME_NL',
    HELO_DYNAMIC_IPADDR: 'HELO_DYNAMIC_IPADDR',
    HELO_DYNAMIC_IPADDR2HELO_DYNAMIC_ROGERS: 'HELO_DYNAMIC_IPADDR2HELO_DYNAMIC_ROGERS',
    HELO_DYNAMIC_SPLIT_IP: 'HELO_DYNAMIC_SPLIT_IP',
    HELO_FRIEND: 'HELO_FRIEND',
    HELO_LH_HOME: 'HELO_LH_HOME',
    HELO_LH_LD: 'HELO_LH_LD',
    HELO_LOCALHOST: 'HELO_LOCALHOST',
    HELO_NO_DOMAIN: 'HELO_NO_DOMAIN',
    HELO_OEM: 'HELO_OEM',
    HELO_STATIC_HOSTHEXHASH_WORD: 'HELO_STATIC_HOSTHEXHASH_WORD',
    HIDE_WIN_STATUS: 'HIDE_WIN_STATUS',
    HIGH_CODEPAGE_URI: 'HIGH_CODEPAGE_URI',
    HK_CTE_RAW: 'HK_CTE_RAW',
    HK_GOLDDUST: 'HK_GOLDDUST',
    HK_LOTTO: 'HK_LOTTO',
    HK_LOTTO_NAME: 'HK_LOTTO_NAME',
    HK_LOTTO_SUBJECT: 'HK_LOTTO_SUBJECT',
    HK_MUCHMONEYHK_NAME_DR: 'HK_MUCHMONEYHK_NAME_DR',
    HK_NAME_DRUGS: 'HK_NAME_DRUGS',
    HK_NAME_FM_DR: 'HK_NAME_FM_DR',
    HK_NAME_FM_FROM: 'HK_NAME_FM_FROM',
    HK_NAME_FM_MR_MRS: 'HK_NAME_FM_MR_MRS',
    HK_NAME_FREE: 'HK_NAME_FREE',
    HK_NAME_FROM: 'HK_NAME_FROM',
    HK_NAME_MR_MRS: 'HK_NAME_MR_MRS',
    HK_PNISHK_PNISES: 'HK_PNISHK_PNISES',
    HK_RANDOM_ENVFROM: 'HK_RANDOM_ENVFROM',
    HK_RANDOM_FROM: 'HK_RANDOM_FROM',
    HK_RANDOM_FROM_NAME: 'HK_RANDOM_FROM_NAME',
    HK_RANDOM_REPLYTO: 'HK_RANDOM_REPLYTO',
    HK_RANDOM_REPLYTO_NAME: 'HK_RANDOM_REPLYTO_NAME',
    HK_RCVD_IP_MULTICASTHK_SCAM: 'HK_RCVD_IP_MULTICASTHK_SCAM',
    HK_SCAM_N1: 'HK_SCAM_N1',
    HK_SCAM_N12: 'HK_SCAM_N12',
    HK_SCAM_N13: 'HK_SCAM_N13',
    HK_SCAM_N14: 'HK_SCAM_N14',
    HK_SCAM_N15: 'HK_SCAM_N15',
    HK_SCAM_N16: 'HK_SCAM_N16',
    HK_SCAM_N3: 'HK_SCAM_N3',
    HK_SCAM_N4: 'HK_SCAM_N4',
    HK_SCAM_N9: 'HK_SCAM_N9',
    HK_SCAM_S1HK_SCAM_S12: 'HK_SCAM_S1HK_SCAM_S12',
    HK_SCAM_S15: 'HK_SCAM_S15',
    HK_SCAM_S22: 'HK_SCAM_S22',
    HK_SCAM_S23: 'HK_SCAM_S23',
    HK_SCAM_S25: 'HK_SCAM_S25',
    HK_SCAM_S3: 'HK_SCAM_S3',
    HK_SCAM_S4: 'HK_SCAM_S4',
    HK_WIN: 'HK_WIN',
    HOSTED_IMG_DIRECT_MX: 'HOSTED_IMG_DIRECT_MX',
    HOSTED_IMG_DQ_UNSUBHOSTED_IMG_FREEM: 'HOSTED_IMG_DQ_UNSUBHOSTED_IMG_FREEM',
    HOSTED_IMG_MULTI: 'HOSTED_IMG_MULTI',
    HOSTED_IMG_MULTI_PUB_01: 'HOSTED_IMG_MULTI_PUB_01',
    HREF_EMPTY_NORDNS: 'HREF_EMPTY_NORDNS',
    HREF_EMPTY_PHPMAIL: 'HREF_EMPTY_PHPMAIL',
    HREF_EMPTY_XANTIABUSE: 'HREF_EMPTY_XANTIABUSE',
    HREF_EMPTY_XAUTHEDHTML_ATTACH: 'HREF_EMPTY_XAUTHEDHTML_ATTACH',
    HTML_BADATTR: 'HTML_BADATTR',
    HTML_BADTAG_40_50: 'HTML_BADTAG_40_50',
    HTML_BADTAG_50_60: 'HTML_BADTAG_50_60',
    HTML_BADTAG_60_70: 'HTML_BADTAG_60_70',
    HTML_BADTAG_90_100: 'HTML_BADTAG_90_100',
    HTML_CHARSET_FARAWAY: 'HTML_CHARSET_FARAWAY',
    HTML_COMMENT_SAVED_URLHTML_COMMENT_SHORT: 'HTML_COMMENT_SAVED_URLHTML_COMMENT_SHORT',
    HTML_EMBEDS: 'HTML_EMBEDS',
    HTML_ENTITY_ASCII: 'HTML_ENTITY_ASCII',
    HTML_ENTITY_ASCII_TINY: 'HTML_ENTITY_ASCII_TINY',
    HTML_EXTRA_CLOSE: 'HTML_EXTRA_CLOSE',
    HTML_FONT_FACE_BAD: 'HTML_FONT_FACE_BAD',
    HTML_FONT_LOW_CONTRASTHTML_FONT_SIZE_HUGE: 'HTML_FONT_LOW_CONTRASTHTML_FONT_SIZE_HUGE',
    HTML_FONT_SIZE_LARGE: 'HTML_FONT_SIZE_LARGE',
    HTML_FONT_TINY: 'HTML_FONT_TINY',
    HTML_FONT_TINY_NORDNS: 'HTML_FONT_TINY_NORDNS',
    HTML_FORMACTION_MAILTO: 'HTML_FORMACTION_MAILTO',
    HTML_IFRAME_SRC: 'HTML_IFRAME_SRC',
    HTML_IMAGE_ONLY_04HTML_IMAGE_ONLY_08: 'HTML_IMAGE_ONLY_04HTML_IMAGE_ONLY_08',
    HTML_IMAGE_ONLY_12: 'HTML_IMAGE_ONLY_12',
    HTML_IMAGE_ONLY_16: 'HTML_IMAGE_ONLY_16',
    HTML_IMAGE_ONLY_20: 'HTML_IMAGE_ONLY_20',
    HTML_IMAGE_ONLY_24: 'HTML_IMAGE_ONLY_24',
    HTML_IMAGE_ONLY_28: 'HTML_IMAGE_ONLY_28',
    HTML_IMAGE_ONLY_32HTML_IMAGE_RATIO_02: 'HTML_IMAGE_ONLY_32HTML_IMAGE_RATIO_02',
    HTML_IMAGE_RATIO_04: 'HTML_IMAGE_RATIO_04',
    HTML_IMAGE_RATIO_06: 'HTML_IMAGE_RATIO_06',
    HTML_IMAGE_RATIO_08: 'HTML_IMAGE_RATIO_08',
    HTML_MESSAGE: 'HTML_MESSAGE',
    HTML_MIME_NO_HTML_TAG: 'HTML_MIME_NO_HTML_TAG',
    HTML_MISSING_CTYPEHTML_NONELEMENT_30_40: 'HTML_MISSING_CTYPEHTML_NONELEMENT_30_40',
    HTML_NONELEMENT_40_50: 'HTML_NONELEMENT_40_50',
    HTML_NONELEMENT_60_70: 'HTML_NONELEMENT_60_70',
    HTML_NONELEMENT_80_90: 'HTML_NONELEMENT_80_90',
    HTML_OBFUSCATE_05_10: 'HTML_OBFUSCATE_05_10',
    HTML_OBFUSCATE_10_20HTML_OBFUSCATE_20_30: 'HTML_OBFUSCATE_10_20HTML_OBFUSCATE_20_30',
    HTML_OBFUSCATE_30_40: 'HTML_OBFUSCATE_30_40',
    HTML_OBFUSCATE_50_60: 'HTML_OBFUSCATE_50_60',
    HTML_OBFUSCATE_70_80: 'HTML_OBFUSCATE_70_80',
    HTML_OBFUSCATE_90_100: 'HTML_OBFUSCATE_90_100',
    HTML_OFF_PAGE: 'HTML_OFF_PAGE',
    HTML_SHORT_CENTERHTML_SHORT_LINK_IMG_1: 'HTML_SHORT_CENTERHTML_SHORT_LINK_IMG_1',
    HTML_SHORT_LINK_IMG_2: 'HTML_SHORT_LINK_IMG_2',
    HTML_SHORT_LINK_IMG_3: 'HTML_SHORT_LINK_IMG_3',
    HTML_SHRT_CMNT_OBFU_MANY: 'HTML_SHRT_CMNT_OBFU_MANY',
    HTML_SINGLET_MANY: 'HTML_SINGLET_MANY',
    HTML_TAG_BALANCE_BODYHTML_TAG_BALANCE_CENTER: 'HTML_TAG_BALANCE_BODYHTML_TAG_BALANCE_CENTER',
    HTML_TAG_BALANCE_HEAD: 'HTML_TAG_BALANCE_HEAD',
    HTML_TAG_EXIST_BGSOUND: 'HTML_TAG_EXIST_BGSOUND',
    HTML_TEXT_INVISIBLE_FONT: 'HTML_TEXT_INVISIBLE_FONT',
    HTML_TEXT_INVISIBLE_STYLE: 'HTML_TEXT_INVISIBLE_STYLE',
    HTML_TITLE_SUBJ_DIFFHTTPS_HTTP_MISMATCH: 'HTML_TITLE_SUBJ_DIFFHTTPS_HTTP_MISMATCH',
    HTTPS_IP_MISMATCH: 'HTTPS_IP_MISMATCH',
    HTTP_77: 'HTTP_77',
    HTTP_ESCAPED_HOST: 'HTTP_ESCAPED_HOST',
    HTTP_EXCESSIVE_ESCAPES: 'HTTP_EXCESSIVE_ESCAPES',
    IMAGESHACK_URI: 'IMAGESHACK_URI',
    IMG_ALT_BRACKETS: 'IMG_ALT_BRACKETS',
    IMG_CID_PART1IMG_DIRECT_TO_MX: 'IMG_CID_PART1IMG_DIRECT_TO_MX',
    IMG_ONLY_FM_DOM_INFO: 'IMG_ONLY_FM_DOM_INFO',
    IMPOTENCE: 'IMPOTENCE',
    INVALID_DATE: 'INVALID_DATE',
    INVALID_DATE_TZ_ABSURD: 'INVALID_DATE_TZ_ABSURD',
    INVALID_MSGID: 'INVALID_MSGID',
    INVALID_TZ_CST: 'INVALID_TZ_CST',
    INVALID_TZ_ESTINVESTMENT_ADVICE: 'INVALID_TZ_ESTINVESTMENT_ADVICE',
    IP_LINK_PLUS: 'IP_LINK_PLUS',
    IRS_SPOOF: 'IRS_SPOOF',
    JAPANESE_UCE_BODY: 'JAPANESE_UCE_BODY',
    JAPANESE_UCE_SUBJECT: 'JAPANESE_UCE_SUBJECT',
    JH_SPAMMY_HEADERS: 'JH_SPAMMY_HEADERS',
    JH_SPAMMY_PATTERN01: 'JH_SPAMMY_PATTERN01',
    JH_SPAMMY_PATTERN02JMQ_CONGRAT: 'JH_SPAMMY_PATTERN02JMQ_CONGRAT',
    JMQ_DROPBOX: 'JMQ_DROPBOX',
    JMQ_IMPORTANT: 'JMQ_IMPORTANT',
    JMQ_PAYPAL2: 'JMQ_PAYPAL2',
    JMQ_PICKUP: 'JMQ_PICKUP',
    JMQ_REALESTATE: 'JMQ_REALESTATE',
    JMQ_RESUME: 'JMQ_RESUME',
    JMQ_RESUME3: 'JMQ_RESUME3',
    JMQ_TRACKR: 'JMQ_TRACKR',
    JMQ_WIRE: 'JMQ_WIRE',
    JM_0800_GMTJM_EXIM_462: 'JM_0800_GMTJM_EXIM_462',
    JM_FAKE_PSMTP_RCVD: 'JM_FAKE_PSMTP_RCVD',
    JM_GMT_RCVD: 'JM_GMT_RCVD',
    JM_HOODIA: 'JM_HOODIA',
    JM_I_FEEL_LUCKY: 'JM_I_FEEL_LUCKY',
    JM_NICE_GIRL: 'JM_NICE_GIRL',
    JM_RCVD_QMAILV1: 'JM_RCVD_QMAILV1',
    JM_REACTOR_MAILER: 'JM_REACTOR_MAILER',
    JM_REMOVE_FROM_URLJM_TORA_XM: 'JM_REMOVE_FROM_URLJM_TORA_XM',
    JOIN_MILLIONS: 'JOIN_MILLIONS',
    JS_FROMCHARCODE: 'JS_FROMCHARCODE',
    KAM_1LINE: 'KAM_1LINE',
    KAM_6C822ECF: 'KAM_6C822ECF',
    KAM_ABOUT: 'KAM_ABOUT',
    KAM_ACNE: 'KAM_ACNE',
    KAM_ADHD: 'KAM_ADHD',
    KAM_ADVANCE: 'KAM_ADVANCE',
    KAM_ADVERT: 'KAM_ADVERT',
    KAM_ADVERT3KAM_ADVERTISE: 'KAM_ADVERT3KAM_ADVERTISE',
    KAM_ADV_EMAIL: 'KAM_ADV_EMAIL',
    KAM_ADWORD: 'KAM_ADWORD',
    KAM_ALARM2: 'KAM_ALARM2',
    KAM_ALERT: 'KAM_ALERT',
    KAM_ANATA: 'KAM_ANATA',
    KAM_ANCESTOR: 'KAM_ANCESTOR',
    KAM_ANDROGEL: 'KAM_ANDROGEL',
    KAM_AP: 'KAM_AP',
    KAM_AQUA: 'KAM_AQUA',
    KAM_AQUARUGKAM_ARREST: 'KAM_AQUARUGKAM_ARREST',
    KAM_ASIAN: 'KAM_ASIAN',
    KAM_ASSASSIN: 'KAM_ASSASSIN',
    KAM_ATTORNEY: 'KAM_ATTORNEY',
    KAM_AUGER: 'KAM_AUGER',
    KAM_AUTONEW2: 'KAM_AUTONEW2',
    KAM_AV: 'KAM_AV',
    KAM_BACKUP: 'KAM_BACKUP',
    KAM_BADAOL: 'KAM_BADAOL',
    KAM_BADPDF2: 'KAM_BADPDF2',
    KAM_BADSWFKAM_BADUNSUB: 'KAM_BADSWFKAM_BADUNSUB',
    KAM_BAD_REVIEW: 'KAM_BAD_REVIEW',
    KAM_BAD_UTF8: 'KAM_BAD_UTF8',
    KAM_BARK: 'KAM_BARK',
    KAM_BBB: 'KAM_BBB',
    KAM_BEAUTY: 'KAM_BEAUTY',
    KAM_BILLS: 'KAM_BILLS',
    KAM_BIZ: 'KAM_BIZ',
    KAM_BLOCK_UTF7: 'KAM_BLOCK_UTF7',
    KAM_BODY: 'KAM_BODY',
    KAM_BUS: 'KAM_BUS',
    KAM_BUSINESSPHONEKAM_CAD: 'KAM_BUSINESSPHONEKAM_CAD',
    KAM_CANDY: 'KAM_CANDY',
    KAM_CARDEAL: 'KAM_CARDEAL',
    KAM_CAREER: 'KAM_CAREER',
    KAM_CASINO: 'KAM_CASINO',
    KAM_CELL: 'KAM_CELL',
    KAM_CHANGELOG: 'KAM_CHANGELOG',
    KAM_CHECK: 'KAM_CHECK',
    KAM_CHICKEN: 'KAM_CHICKEN',
    KAM_CHOSEN: 'KAM_CHOSEN',
    KAM_CLAIMS: 'KAM_CLAIMS',
    KAM_CLOUDKAM_CMS: 'KAM_CLOUDKAM_CMS',
    KAM_CNN: 'KAM_CNN',
    KAM_COBRA: 'KAM_COBRA',
    KAM_COLLECT: 'KAM_COLLECT',
    KAM_COMBOJDR: 'KAM_COMBOJDR',
    KAM_COMPANY1: 'KAM_COMPANY1',
    KAM_COMPANY2: 'KAM_COMPANY2',
    KAM_CONTACTME: 'KAM_CONTACTME',
    KAM_CONTRACT: 'KAM_CONTRACT',
    KAM_CRYPTO: 'KAM_CRYPTO',
    KAM_DATINGTIPSKAM_DEALS: 'KAM_DATINGTIPSKAM_DEALS',
    KAM_DEATH: 'KAM_DEATH',
    KAM_DEATHINSURE: 'KAM_DEATHINSURE',
    KAM_DENTIST: 'KAM_DENTIST',
    KAM_DETOX: 'KAM_DETOX',
    KAM_DIGITALWALLET: 'KAM_DIGITALWALLET',
    KAM_DIRECT: 'KAM_DIRECT',
    KAM_DISCAIR: 'KAM_DISCAIR',
    KAM_DISH: 'KAM_DISH',
    KAM_DIV: 'KAM_DIV',
    KAM_DOMAIN_SALE_3KAM_DOMAIN_SALE_INTRUDE: 'KAM_DOMAIN_SALE_3KAM_DOMAIN_SALE_INTRUDE',
    KAM_DON: 'KAM_DON',
    KAM_DON2: 'KAM_DON2',
    KAM_DRAPES: 'KAM_DRAPES',
    KAM_DRILL: 'KAM_DRILL',
    KAM_DRIVE: 'KAM_DRIVE',
    KAM_DROPBOX: 'KAM_DROPBOX',
    KAM_DRUG: 'KAM_DRUG',
    KAM_DUCHESS: 'KAM_DUCHESS',
    KAM_DYNIP: 'KAM_DYNIP',
    KAM_EBAYKAM_EGG: 'KAM_EBAYKAM_EGG',
    KAM_EMAILPHISH: 'KAM_EMAILPHISH',
    KAM_EMAILQUESTION: 'KAM_EMAILQUESTION',
    KAM_EMMAPP_WEB_COM: 'KAM_EMMAPP_WEB_COM',
    KAM_ERP: 'KAM_ERP',
    KAM_EVICTION: 'KAM_EVICTION',
    KAM_EXPOPIRATE: 'KAM_EXPOPIRATE',
    KAM_FACE: 'KAM_FACE',
    KAM_FACEBOOKMAILKAM_FAKEBBB: 'KAM_FACEBOOKMAILKAM_FAKEBBB',
    KAM_FAKEPDF: 'KAM_FAKEPDF',
    KAM_FAKEVOUCHER: 'KAM_FAKEVOUCHER',
    KAM_FARM: 'KAM_FARM',
    KAM_FAST: 'KAM_FAST',
    KAM_FINGERHUT: 'KAM_FINGERHUT',
    KAM_FLAG: 'KAM_FLAG',
    KAM_FLASH: 'KAM_FLASH',
    KAM_FLEXHOSE: 'KAM_FLEXHOSE',
    KAM_FOOTBALL: 'KAM_FOOTBALL',
    KAM_FOUNTAINOFYOUTHKAM_FRIEND: 'KAM_FOUNTAINOFYOUTHKAM_FRIEND',
    KAM_FROMNUM: 'KAM_FROMNUM',
    KAM_FUNERAL: 'KAM_FUNERAL',
    KAM_FUNERAL2: 'KAM_FUNERAL2',
    KAM_GALLERY: 'KAM_GALLERY',
    KAM_GALLERY2: 'KAM_GALLERY2',
    KAM_GARAGE: 'KAM_GARAGE',
    KAM_GAS: 'KAM_GAS',
    KAM_GEO_STRING2: 'KAM_GEO_STRING2',
    KAM_GERMAN_BUSINESS_CONTACTSKAM_GEVALIA: 'KAM_GERMAN_BUSINESS_CONTACTSKAM_GEVALIA',
    KAM_GIFT2: 'KAM_GIFT2',
    KAM_GINA: 'KAM_GINA',
    KAM_GIRLS: 'KAM_GIRLS',
    KAM_GIVE: 'KAM_GIVE',
    KAM_GOODAOL: 'KAM_GOODAOL',
    KAM_GOOGLE: 'KAM_GOOGLE',
    KAM_GOOGLE2: 'KAM_GOOGLE2',
    KAM_GOOGLEPHISH: 'KAM_GOOGLEPHISH',
    KAM_GOOGLE_AWARD: 'KAM_GOOGLE_AWARD',
    KAM_GOVTKAM_GRABBAG4: 'KAM_GOVTKAM_GRABBAG4',
    KAM_GRABBAG5: 'KAM_GRABBAG5',
    KAM_GRANT: 'KAM_GRANT',
    KAM_GRASS: 'KAM_GRASS',
    KAM_GRIPPY: 'KAM_GRIPPY',
    KAM_GUN: 'KAM_GUN',
    KAM_H1QNUM: 'KAM_H1QNUM',
    KAM_H1QNUM2: 'KAM_H1QNUM2',
    KAM_HANGOVER: 'KAM_HANGOVER',
    KAM_HAPPYTALK: 'KAM_HAPPYTALK',
    KAM_HEALTHKAM_HEALTH2: 'KAM_HEALTHKAM_HEALTH2',
    KAM_HEALTH3: 'KAM_HEALTH3',
    KAM_HEX: 'KAM_HEX',
    KAM_HIDDEN_URI: 'KAM_HIDDEN_URI',
    KAM_HIP: 'KAM_HIP',
    KAM_HIRE: 'KAM_HIRE',
    KAM_HOLIDAY: 'KAM_HOLIDAY',
    KAM_HOLLY: 'KAM_HOLLY',
    KAM_HOME: 'KAM_HOME',
    KAM_HOMESALE: 'KAM_HOMESALE',
    KAM_HONOR: 'KAM_HONOR',
    KAM_HOODIAKAM_HOOKUP: 'KAM_HOODIAKAM_HOOKUP',
    KAM_HOSE: 'KAM_HOSE',
    KAM_HOWRU: 'KAM_HOWRU',
    KAM_HSR: 'KAM_HSR',
    KAM_IDENTNET: 'KAM_IDENTNET',
    KAM_IFRAME2: 'KAM_IFRAME2',
    KAM_IFRAME3: 'KAM_IFRAME3',
    KAM_INVESTCOUNTRY: 'KAM_INVESTCOUNTRY',
    KAM_INVOICE: 'KAM_INVOICE',
    KAM_INVOICE2: 'KAM_INVOICE2',
    KAM_ITCKAM_JEWELRY: 'KAM_ITCKAM_JEWELRY',
    KAM_JOB: 'KAM_JOB',
    KAM_JOINT: 'KAM_JOINT',
    KAM_JUDGE: 'KAM_JUDGE',
    KAM_JURY: 'KAM_JURY',
    KAM_KITCHEN: 'KAM_KITCHEN',
    KAM_KIWIBANK: 'KAM_KIWIBANK',
    KAM_LANDSCAPING: 'KAM_LANDSCAPING',
    KAM_LANG: 'KAM_LANG',
    KAM_LASIK: 'KAM_LASIK',
    KAM_LEARN: 'KAM_LEARN',
    KAM_LEDKAM_LENS: 'KAM_LEDKAM_LENS',
    KAM_LIKE: 'KAM_LIKE',
    KAM_LINGERIE: 'KAM_LINGERIE',
    KAM_LIVEURI2: 'KAM_LIVEURI2',
    KAM_LOCAL_TEST1: 'KAM_LOCAL_TEST1',
    KAM_LOGO: 'KAM_LOGO',
    KAM_LUNAR: 'KAM_LUNAR',
    KAM_LUNAR2: 'KAM_LUNAR2',
    KAM_MAID: 'KAM_MAID',
    KAM_MANYDOTS: 'KAM_MANYDOTS',
    KAM_MASCARAKAM_MASSERROR: 'KAM_MASCARAKAM_MASSERROR',
    KAM_MATCH: 'KAM_MATCH',
    KAM_MED: 'KAM_MED',
    KAM_MED2: 'KAM_MED2',
    KAM_MEDICAL: 'KAM_MEDICAL',
    KAM_MEDTOUR: 'KAM_MEDTOUR',
    KAM_MERCHANT: 'KAM_MERCHANT',
    KAM_MESH: 'KAM_MESH',
    KAM_MGCS: 'KAM_MGCS',
    KAM_MILLIONAIRE: 'KAM_MILLIONAIRE',
    KAM_MMS: 'KAM_MMS',
    KAM_MM_FOREXKAM_MONCLER: 'KAM_MM_FOREXKAM_MONCLER',
    KAM_MOP: 'KAM_MOP',
    KAM_MOVIE: 'KAM_MOVIE',
    KAM_MSNBR_REDIR: 'KAM_MSNBR_REDIR',
    KAM_MSN_STRING: 'KAM_MSN_STRING',
    KAM_MUSTREAD: 'KAM_MUSTREAD',
    KAM_NEUROLOGICAL: 'KAM_NEUROLOGICAL',
    KAM_NEWNOTICE: 'KAM_NEWNOTICE',
    KAM_NEWNOTICE2: 'KAM_NEWNOTICE2',
    KAM_NEWSKAM_NEW_CREDITCARD: 'KAM_NEWSKAM_NEW_CREDITCARD',
    KAM_NIGERIAN2: 'KAM_NIGERIAN2',
    KAM_NITROXIN1: 'KAM_NITROXIN1',
    KAM_NOISE1: 'KAM_NOISE1',
    KAM_NOMORE: 'KAM_NOMORE',
    KAM_NOTIFY2: 'KAM_NOTIFY2',
    KAM_NUMEROLOGY: 'KAM_NUMEROLOGY',
    KAM_NURSE: 'KAM_NURSE',
    KAM_NUWAVE: 'KAM_NUWAVE',
    KAM_OBFURIKAM_OBFU_LOANS: 'KAM_OBFURIKAM_OBFU_LOANS',
    KAM_OCEANSBOUNTY: 'KAM_OCEANSBOUNTY',
    KAM_OPRAH: 'KAM_OPRAH',
    KAM_ORDER: 'KAM_ORDER',
    KAM_OVERPAY: 'KAM_OVERPAY',
    KAM_OWAPHISH1: 'KAM_OWAPHISH1',
    KAM_PACKAGE: 'KAM_PACKAGE',
    KAM_PAGE: 'KAM_PAGE',
    KAM_PAINT: 'KAM_PAINT',
    KAM_PAPERLESSKAM_PASSWORD: 'KAM_PAPERLESSKAM_PASSWORD',
    KAM_PAYMENT_LOWERED: 'KAM_PAYMENT_LOWERED',
    KAM_PAYPAL2: 'KAM_PAYPAL2',
    KAM_PEEL: 'KAM_PEEL',
    KAM_PERPARK: 'KAM_PERPARK',
    KAM_PEST: 'KAM_PEST',
    KAM_PET: 'KAM_PET',
    KAM_PET2: 'KAM_PET2',
    KAM_PHISH1: 'KAM_PHISH1',
    KAM_PHISH2: 'KAM_PHISH2',
    KAM_PHISH3KAM_PIC: 'KAM_PHISH3KAM_PIC',
    KAM_PILLS: 'KAM_PILLS',
    KAM_PILLS2: 'KAM_PILLS2',
    KAM_PIZZA: 'KAM_PIZZA',
    KAM_POLY: 'KAM_POLY',
    KAM_POWER: 'KAM_POWER',
    KAM_PRIV: 'KAM_PRIV',
    KAM_PRODUCT: 'KAM_PRODUCT',
    KAM_PROFORMA: 'KAM_PROFORMA',
    KAM_PROPERTY: 'KAM_PROPERTY',
    KAM_PSYCHIC: 'KAM_PSYCHIC',
    KAM_PUBLICKAM_QTJARS: 'KAM_PUBLICKAM_QTJARS',
    KAM_QUOTA: 'KAM_QUOTA',
    KAM_RAT1: 'KAM_RAT1',
    KAM_RAT2: 'KAM_RAT2',
    KAM_RE: 'KAM_RE',
    KAM_REACHBASE: 'KAM_REACHBASE',
    KAM_REAL: 'KAM_REAL',
    KAM_REAL2: 'KAM_REAL2',
    KAM_REALLY_FAKE_DELIVER: 'KAM_REALLY_FAKE_DELIVER',
    KAM_RECALL: 'KAM_RECALL',
    KAM_REFINEWKAM_REFINEW2: 'KAM_REFINEWKAM_REFINEW2',
    KAM_RELIGION: 'KAM_RELIGION',
    KAM_REMEMBERWHEN: 'KAM_REMEMBERWHEN',
    KAM_REPLACE: 'KAM_REPLACE',
    KAM_REVIEW: 'KAM_REVIEW',
    KAM_REWARD: 'KAM_REWARD',
    KAM_RE_PLUS: 'KAM_RE_PLUS',
    KAM_RICH: 'KAM_RICH',
    KAM_RUIN: 'KAM_RUIN',
    KAM_RXPLAN: 'KAM_RXPLAN',
    KAM_SALEKAM_SALEA: 'KAM_SALEKAM_SALEA',
    KAM_SANTA: 'KAM_SANTA',
    KAM_SCHOOL: 'KAM_SCHOOL',
    KAM_SCOOTER: 'KAM_SCOOTER',
    KAM_SECURITY: 'KAM_SECURITY',
    KAM_SEENTHIS: 'KAM_SEENTHIS',
    KAM_SELL: 'KAM_SELL',
    KAM_SELLPHONE: 'KAM_SELLPHONE',
    KAM_SENIOR_DATING: 'KAM_SENIOR_DATING',
    KAM_SEO: 'KAM_SEO',
    KAM_SETTINGKAM_SETTING2: 'KAM_SETTINGKAM_SETTING2',
    KAM_SETTLEMENT: 'KAM_SETTLEMENT',
    KAM_SEX04: 'KAM_SEX04',
    KAM_SEX05: 'KAM_SEX05',
    KAM_SEX06: 'KAM_SEX06',
    KAM_SEX_AFFAIR: 'KAM_SEX_AFFAIR',
    KAM_SHADYCC: 'KAM_SHADYCC',
    KAM_SHAM: 'KAM_SHAM',
    KAM_SHARP: 'KAM_SHARP',
    KAM_SHOCK: 'KAM_SHOCK',
    KAM_SHOPKAM_SINGING: 'KAM_SHOPKAM_SINGING',
    KAM_SKINCELL: 'KAM_SKINCELL',
    KAM_SKYPE: 'KAM_SKYPE',
    KAM_SLICEOMATIC: 'KAM_SLICEOMATIC',
    KAM_SMOKE2: 'KAM_SMOKE2',
    KAM_SNORE: 'KAM_SNORE',
    KAM_SOCKET: 'KAM_SOCKET',
    KAM_SOFTWARE: 'KAM_SOFTWARE',
    KAM_SPAMJDR: 'KAM_SPAMJDR',
    KAM_SPAMKINGKAM_SPY: 'KAM_SPAMKINGKAM_SPY',
    KAM_STAR: 'KAM_STAR',
    KAM_STATLER: 'KAM_STATLER',
    KAM_STOCKOBFU: 'KAM_STOCKOBFU',
    KAM_STUDENTLOAN: 'KAM_STUDENTLOAN',
    KAM_SUNGLASSES: 'KAM_SUNGLASSES',
    KAM_SUPERHUMAN: 'KAM_SUPERHUMAN',
    KAM_TAX2: 'KAM_TAX2',
    KAM_TESTOSTERONE: 'KAM_TESTOSTERONE',
    KAM_TIMEGEOKAM_TINNI: 'KAM_TIMEGEOKAM_TINNI',
    KAM_TINNITUS: 'KAM_TINNITUS',
    KAM_TINYURL: 'KAM_TINYURL',
    KAM_TIP: 'KAM_TIP',
    KAM_TIRES: 'KAM_TIRES',
    KAM_TOLL: 'KAM_TOLL',
    KAM_TOURS: 'KAM_TOURS',
    KAM_TRACK: 'KAM_TRACK',
    KAM_TRAINING: 'KAM_TRAINING',
    KAM_TRUMPCOIN: 'KAM_TRUMPCOIN',
    KAM_TUPPERWAREKAM_TWIT: 'KAM_TUPPERWAREKAM_TWIT',
    KAM_UKINV: 'KAM_UKINV',
    KAM_UNSUB: 'KAM_UNSUB',
    KAM_UPS: 'KAM_UPS',
    KAM_URONLINE: 'KAM_URONLINE',
    KAM_URUNIT: 'KAM_URUNIT',
    KAM_URZEST: 'KAM_URZEST',
    KAM_USB: 'KAM_USB',
    KAM_VALENTINE: 'KAM_VALENTINE',
    KAM_VIAGRA4: 'KAM_VIAGRA4',
    KAM_VIAGRA8: 'KAM_VIAGRA8',
    KAM_VIAGRA9KAM_WATER: 'KAM_VIAGRA9KAM_WATER',
    KAM_WEB: 'KAM_WEB',
    KAM_WEB_OBFUSCATION: 'KAM_WEB_OBFUSCATION',
    KAM_WEED: 'KAM_WEED',
    KAM_WEIGHT2: 'KAM_WEIGHT2',
    KAM_WEIRDTRICK2: 'KAM_WEIRDTRICK2',
    KAM_WHATS: 'KAM_WHATS',
    KAM_WHITEN: 'KAM_WHITEN',
    KAM_WHOSWHO2: 'KAM_WHOSWHO2',
    KAM_WORKHOMEKAM_WORKHOME2: 'KAM_WORKHOMEKAM_WORKHOME2',
    KAM_WRITING: 'KAM_WRITING',
    KAM_WTA: 'KAM_WTA',
    KAM_XEROX: 'KAM_XEROX',
    KAM_ZERODAY3: 'KAM_ZERODAY3',
    KB_CTYPE_SPACE: 'KB_CTYPE_SPACE',
    KB_CTYPE_SP_MOZ: 'KB_CTYPE_SP_MOZ',
    KB_DATE_CONTAINS_TAB: 'KB_DATE_CONTAINS_TAB',
    KB_FAKED_THE_BATKB_FORGED_MOZ4: 'KB_FAKED_THE_BATKB_FORGED_MOZ4',
    KB_RATWARE_BOUNDARY: 'KB_RATWARE_BOUNDARY',
    KB_RATWARE_MSGID: 'KB_RATWARE_MSGID',
    KB_RATWARE_OUTLOOK_08: 'KB_RATWARE_OUTLOOK_08',
    KB_RATWARE_OUTLOOK_12: 'KB_RATWARE_OUTLOOK_12',
    KB_RATWARE_OUTLOOK_16: 'KB_RATWARE_OUTLOOK_16',
    KB_RATWARE_OUTLOOK_MIDKB_WAM_LONELY_WOMEN: 'KB_RATWARE_OUTLOOK_MIDKB_WAM_LONELY_WOMEN',
    KHOP_BIG_TO_CC: 'KHOP_BIG_TO_CC',
    KHOP_BOTNET_4: 'KHOP_BOTNET_4',
    KHOP_BOTNET_7: 'KHOP_BOTNET_7',
    KHOP_BOTNET_9: 'KHOP_BOTNET_9',
    KHOP_BOTNET_UNCLEAN: 'KHOP_BOTNET_UNCLEAN',
    KHOP_DYNAMIC: 'KHOP_DYNAMIC',
    KHOP_FAKE_EBAYKHOP_HELO_FCRDNS: 'KHOP_FAKE_EBAYKHOP_HELO_FCRDNS',
    KHOP_JS_OBFUSCATION: 'KHOP_JS_OBFUSCATION',
    KHOP_NO_FULL_NAME: 'KHOP_NO_FULL_NAME',
    KHOP_UNSUB_EMAIL: 'KHOP_UNSUB_EMAIL',
    KHOP_UNSUB_LINK: 'KHOP_UNSUB_LINK',
    KOREAN_UCE_SUBJECT: 'KOREAN_UCE_SUBJECT',
    LARGE_PCT_AFTER_MANYLAZY_LISTWASHING: 'LARGE_PCT_AFTER_MANYLAZY_LISTWASHING',
    LH_URI_DOM_IN_PATH: 'LH_URI_DOM_IN_PATH',
    LINKEDIN_IMG_NOT_RCVD_LNKN: 'LINKEDIN_IMG_NOT_RCVD_LNKN',
    LIST_PARTIAL: 'LIST_PARTIAL',
    LIST_PRTL_PUMPDUMP: 'LIST_PRTL_PUMPDUMP',
    LIST_PRTL_SAME_USER: 'LIST_PRTL_SAME_USER',
    LIVEFILESTORELIVE_PORN: 'LIVEFILESTORELIVE_PORN',
    LOCALPART_IN_SUBJECT: 'LOCALPART_IN_SUBJECT',
    LOCAL_BAD_FROM: 'LOCAL_BAD_FROM',
    LOLLY_419: 'LOLLY_419',
    LONGLN_LOW_CONTRAST: 'LONGLN_LOW_CONTRAST',
    LONGWORDS: 'LONGWORDS',
    LONG_HEX_URI: 'LONG_HEX_URI',
    LONG_IMG_URI: 'LONG_IMG_URI',
    LONG_INVISIBLE_TEXTLONG_TERM_PRICE: 'LONG_INVISIBLE_TEXTLONG_TERM_PRICE',
    LOOPHOLE_1: 'LOOPHOLE_1',
    LOTS_OF_MONEY: 'LOTS_OF_MONEY',
    LOTTERY_1: 'LOTTERY_1',
    LOTTERY_PH_004470: 'LOTTERY_PH_004470',
    LOTTO_AGENT: 'LOTTO_AGENT',
    LOTTO_AGENT_FM: 'LOTTO_AGENT_FM',
    LOTTO_AGENT_RPLY: 'LOTTO_AGENT_RPLY',
    LOTTO_DEPTLOTTO_URI: 'LOTTO_DEPTLOTTO_URI',
    LOW_PRICE: 'LOW_PRICE',
    LUCRATIVE: 'LUCRATIVE',
    L_SPAM_TOOL_13: 'L_SPAM_TOOL_13',
    MAILER_EQ_ORG: 'MAILER_EQ_ORG',
    MAILING_LIST_MULTI: 'MAILING_LIST_MULTI',
    MALE_ENHANCE: 'MALE_ENHANCE',
    MALFORMED_FREEMAIL: 'MALFORMED_FREEMAIL',
    MALF_HTML_B64MALWARE_HACKED_URI: 'MALF_HTML_B64MALWARE_HACKED_URI',
    MALWARE_NORDNS: 'MALWARE_NORDNS',
    MALWARE_PASSWORD: 'MALWARE_PASSWORD',
    MALW_ATTACH: 'MALW_ATTACH',
    MANY_APPARENTLY_TO: 'MANY_APPARENTLY_TO',
    MANY_PILL_PRICE: 'MANY_PILL_PRICE',
    MANY_SPAN_IN_TEXT: 'MANY_SPAN_IN_TEXT',
    MANY_SUBDOMMARKETING_PARTNERS: 'MANY_SUBDOMMARKETING_PARTNERS',
    MAY_BE_FORGED: 'MAY_BE_FORGED',
    MDN_BOTCHED: 'MDN_BOTCHED',
    MICROSOFT_EXECUTABLE: 'MICROSOFT_EXECUTABLE',
    MID_DEGREES: 'MID_DEGREES',
    MILLION_HUNDRED: 'MILLION_HUNDRED',
    MILLION_USD: 'MILLION_USD',
    MIMEOLE_DIRECT_TO_MXMIMEPART_LIMIT_EXCEEDED: 'MIMEOLE_DIRECT_TO_MXMIMEPART_LIMIT_EXCEEDED',
    MIME_BAD_ISO_CHARSET: 'MIME_BAD_ISO_CHARSET',
    MIME_BASE64_BLANKS: 'MIME_BASE64_BLANKS',
    MIME_BASE64_TEXT: 'MIME_BASE64_TEXT',
    MIME_BOUND_DD_DIGITS: 'MIME_BOUND_DD_DIGITS',
    MIME_BOUND_DIGITS_15MIME_BOUND_EQ_REL: 'MIME_BOUND_DIGITS_15MIME_BOUND_EQ_REL',
    MIME_BOUND_MANY_HEX: 'MIME_BOUND_MANY_HEX',
    MIME_CHARSET_FARAWAY: 'MIME_CHARSET_FARAWAY',
    MIME_HEADER_CTYPE_ONLY: 'MIME_HEADER_CTYPE_ONLY',
    MIME_HTML_MOSTLY: 'MIME_HTML_MOSTLY',
    MIME_HTML_ONLY: 'MIME_HTML_ONLY',
    MIME_HTML_ONLY_MULTIMIME_MALF: 'MIME_HTML_ONLY_MULTIMIME_MALF',
    MIME_NO_TEXT: 'MIME_NO_TEXT',
    MIME_PHP_NO_TEXT: 'MIME_PHP_NO_TEXT',
    MIME_QP_LONG_LINE: 'MIME_QP_LONG_LINE',
    MIME_SUSPECT_NAME: 'MIME_SUSPECT_NAME',
    MISSING_DATE: 'MISSING_DATE',
    MISSING_FROM: 'MISSING_FROM',
    MISSING_HB_SEP: 'MISSING_HB_SEP',
    MISSING_HEADERSMISSING_MID: 'MISSING_HEADERSMISSING_MID',
    MISSING_MIMEOLE: 'MISSING_MIMEOLE',
    MISSING_MIME_HB_SEP: 'MISSING_MIME_HB_SEP',
    MISSING_SUBJECT: 'MISSING_SUBJECT',
    MIXED_AREA_CASE: 'MIXED_AREA_CASE',
    MIXED_CENTER_CASE: 'MIXED_CENTER_CASE',
    MIXED_ES: 'MIXED_ES',
    MIXED_FONT_CASEMIXED_HREF_CASE: 'MIXED_FONT_CASEMIXED_HREF_CASE',
    MIXED_IMG_CASE: 'MIXED_IMG_CASE',
    MONERO_DEADLINE: 'MONERO_DEADLINE',
    MONERO_EXTORT_01: 'MONERO_EXTORT_01',
    MONERO_MALWARE: 'MONERO_MALWARE',
    MONERO_PAY_ME: 'MONERO_PAY_ME',
    MONEY_12LTRDOM: 'MONEY_12LTRDOM',
    MONEY_ATM_CARDMONEY_BACK: 'MONEY_ATM_CARDMONEY_BACK',
    MONEY_FORM: 'MONEY_FORM',
    MONEY_FORM_SHORT: 'MONEY_FORM_SHORT',
    MONEY_FRAUD_3: 'MONEY_FRAUD_3',
    MONEY_FRAUD_5: 'MONEY_FRAUD_5',
    MONEY_FRAUD_8: 'MONEY_FRAUD_8',
    MONEY_FREEMAIL: 'MONEY_FREEMAIL',
    MONEY_FREEMAIL_REPTO: 'MONEY_FREEMAIL_REPTO',
    MONEY_FROM_41MONEY_FROM_MISSP: 'MONEY_FROM_41MONEY_FROM_MISSP',
    MONEY_LOTTERY: 'MONEY_LOTTERY',
    MONEY_NOHTML: 'MONEY_NOHTML',
    MONEY_PERCENT: 'MONEY_PERCENT',
    MORE_SEX: 'MORE_SEX',
    MPART_ALT_DIFF: 'MPART_ALT_DIFF',
    MPART_ALT_DIFF_COUNT: 'MPART_ALT_DIFF_COUNT',
    MSGID_DOLLARS_RANDOMMSGID_DOLLARS_URI_IMG: 'MSGID_DOLLARS_RANDOMMSGID_DOLLARS_URI_IMG',
    MSGID_FROM_MTA_HEADER: 'MSGID_FROM_MTA_HEADER',
    MSGID_HDR_MALF: 'MSGID_HDR_MALF',
    MSGID_MULTIPLE_AT: 'MSGID_MULTIPLE_AT',
    MSGID_OUTLOOK_INVALID: 'MSGID_OUTLOOK_INVALID',
    MSGID_RANDY: 'MSGID_RANDY',
    MSGID_SHORTMSGID_SPAM_CAPS: 'MSGID_SHORTMSGID_SPAM_CAPS',
    MSGID_SPAM_LETTERS: 'MSGID_SPAM_LETTERS',
    MSGID_YAHOO_CAPS: 'MSGID_YAHOO_CAPS',
    MSM_PRIO_REPTO: 'MSM_PRIO_REPTO',
    MSNBC_HDR_ORDER: 'MSNBC_HDR_ORDER',
    MSNBC_MESSAGEGUID: 'MSNBC_MESSAGEGUID',
    MSNBC_THREAD_INDEX: 'MSNBC_THREAD_INDEX',
    MSOE_MID_WRONG_CASEMULTIPART_ALT_NON_TEXT: 'MSOE_MID_WRONG_CASEMULTIPART_ALT_NON_TEXT',
    MULTI_FORGED: 'MULTI_FORGED',
    NAME_EMAIL_DIFF: 'NAME_EMAIL_DIFF',
    NA_DOLLARS: 'NA_DOLLARS',
    NEWEGG_IMG_NOT_RCVD_NEGG: 'NEWEGG_IMG_NOT_RCVD_NEGG',
    NEW_PRODUCTS: 'NEW_PRODUCTS',
    NICE_REPLY_A: 'NICE_REPLY_A',
    NML_ADSP_CUSTOM_HIGHNML_ADSP_CUSTOM_LOW: 'NML_ADSP_CUSTOM_HIGHNML_ADSP_CUSTOM_LOW',
    NML_ADSP_CUSTOM_MED: 'NML_ADSP_CUSTOM_MED',
    NONEXISTENT_CHARSET: 'NONEXISTENT_CHARSET',
    NORDNS_LOW_CONTRAST: 'NORDNS_LOW_CONTRAST',
    NORMAL_HTTP_TO_IP: 'NORMAL_HTTP_TO_IP',
    NOT_ADVISOR: 'NOT_ADVISOR',
    NOT_A_PERSONNOT_SPAM: 'NOT_A_PERSONNOT_SPAM',
    NO_DNS_FOR_FROM: 'NO_DNS_FOR_FROM',
    NO_FM_NAME_IP_HOSTN: 'NO_FM_NAME_IP_HOSTN',
    NO_HEADERS_MESSAGE: 'NO_HEADERS_MESSAGE',
    NO_MEDICAL: 'NO_MEDICAL',
    NO_PRESCRIPTION: 'NO_PRESCRIPTION',
    NO_RDNS_DOTCOM_HELO: 'NO_RDNS_DOTCOM_HELO',
    NO_RECEIVEDNO_RELAYS: 'NO_RECEIVEDNO_RELAYS',
    NSL_FREEMAIL_M1: 'NSL_FREEMAIL_M1',
    NSL_FREEMAIL_M2: 'NSL_FREEMAIL_M2',
    NSL_FREEMAIL_SUBJ: 'NSL_FREEMAIL_SUBJ',
    NSL_RCVD_FROM_USER: 'NSL_RCVD_FROM_USER',
    NSL_RCVD_HELO_USER: 'NSL_RCVD_HELO_USER',
    NSL_TO_ENDS_COMMA: 'NSL_TO_ENDS_COMMA',
    NULL_IN_BODYNUMERIC_HTTP_ADDR: 'NULL_IN_BODYNUMERIC_HTTP_ADDR',
    OBFUSCATING_COMMENT: 'OBFUSCATING_COMMENT',
    OBFU_ATTACH_MISSP: 'OBFU_ATTACH_MISSP',
    OBFU_BITCOIN: 'OBFU_BITCOIN',
    OBFU_DOC_ATTACH: 'OBFU_DOC_ATTACH',
    OBFU_GIF_ATTACH: 'OBFU_GIF_ATTACH',
    OBFU_HTML_ATTACH: 'OBFU_HTML_ATTACH',
    OBFU_HTML_ATT_MALWOBFU_JPG_ATTACH: 'OBFU_HTML_ATT_MALWOBFU_JPG_ATTACH',
    OBFU_JVSCR_ESC: 'OBFU_JVSCR_ESC',
    OBFU_PDF_ATTACH: 'OBFU_PDF_ATTACH',
    OBFU_TEXT_ATTACH: 'OBFU_TEXT_ATTACH',
    OBFU_UNSUB_UL: 'OBFU_UNSUB_UL',
    OBSCURED_EMAIL: 'OBSCURED_EMAIL',
    ODD_FREEM_REPTO: 'ODD_FREEM_REPTO',
    ONE_TIME: 'ONE_TIME',
    ONLINE_MKTG_CNSLTONLINE_PHARMACY: 'ONLINE_MKTG_CNSLTONLINE_PHARMACY',
    OOOBOUNCE_MESSAGE: 'OOOBOUNCE_MESSAGE',
    OPERA_MID_NON_OP: 'OPERA_MID_NON_OP',
    OPERA_MID_NO_DIGIT: 'OPERA_MID_NO_DIGIT',
    ORS: 'ORS',
    PART_CID_STOCK: 'PART_CID_STOCK',
    PART_CID_STOCK_LESS: 'PART_CID_STOCK_LESS',
    PDS_BAD_THREAD_QP_64PDS_BTC_ID: 'PDS_BAD_THREAD_QP_64PDS_BTC_ID',
    PDS_BTC_MSGID: 'PDS_BTC_MSGID',
    PDS_DBL_URL_LINKBAIT: 'PDS_DBL_URL_LINKBAIT',
    PDS_FRNOM_TODOM_DBL_URL: 'PDS_FRNOM_TODOM_DBL_URL',
    PDS_FRNOM_TODOM_NAKED_TO: 'PDS_FRNOM_TODOM_NAKED_TO',
    PDS_FROM_2_EMAILS: 'PDS_FROM_2_EMAILS',
    PDS_FROM_NAME_TO_DOMAINPDS_HELO_SPF_FAIL: 'PDS_FROM_NAME_TO_DOMAINPDS_HELO_SPF_FAIL',
    PDS_OTHER_BAD_TLD: 'PDS_OTHER_BAD_TLD',
    PDS_TO_EQ_FROM_NAME: 'PDS_TO_EQ_FROM_NAME',
    PERCENT_RANDOM: 'PERCENT_RANDOM',
    PHARMACOURT_BIZ: 'PHARMACOURT_BIZ',
    PHISHING_FREEMAIL: 'PHISHING_FREEMAIL',
    PHISH_ATTACH: 'PHISH_ATTACH',
    PHISH_AZURE_CLOUDAPPPHISH_FBASEAPP: 'PHISH_AZURE_CLOUDAPPPHISH_FBASEAPP',
    PHP_NOVER_MUA: 'PHP_NOVER_MUA',
    PHP_ORIG_SCRIPT: 'PHP_ORIG_SCRIPT',
    PHP_SCRIPT: 'PHP_SCRIPT',
    PHP_SCRIPT_MUA: 'PHP_SCRIPT_MUA',
    PLING_QUERY: 'PLING_QUERY',
    POSSIBLE_APPLE_PHISH_02: 'POSSIBLE_APPLE_PHISH_02',
    POSSIBLE_EBAY_PHISH_02POSSIBLE_PAYPAL_PHISH_01: 'POSSIBLE_EBAY_PHISH_02POSSIBLE_PAYPAL_PHISH_01',
    POSSIBLE_PAYPAL_PHISH_02: 'POSSIBLE_PAYPAL_PHISH_02',
    POSTCARD_01: 'POSTCARD_01',
    POSTCARD_02: 'POSTCARD_02',
    POSTCARD_03: 'POSTCARD_03',
    POSTCARD_04: 'POSTCARD_04',
    POSTCARD_05: 'POSTCARD_05',
    POSTCARD_06POSTCARD_07: 'POSTCARD_06POSTCARD_07',
    POSTCARD_08: 'POSTCARD_08',
    POSTCARD_09: 'POSTCARD_09',
    POSTCARD_DQ: 'POSTCARD_DQ',
    POSTCARD_EXE: 'POSTCARD_EXE',
    PP_MIME_FAKE_ASCII_TEXT: 'PP_MIME_FAKE_ASCII_TEXT',
    PP_TOO_MUCH_UNICODE02: 'PP_TOO_MUCH_UNICODE02',
    PP_TOO_MUCH_UNICODE05PREST_NON_ACCREDITED: 'PP_TOO_MUCH_UNICODE05PREST_NON_ACCREDITED',
    PREVENT_NONDELIVERY: 'PREVENT_NONDELIVERY',
    PRICES_ARE_AFFORDABLE: 'PRICES_ARE_AFFORDABLE',
    PROLO_HOSTING_NET4FREE_CHK1: 'PROLO_HOSTING_NET4FREE_CHK1',
    PROLO_HOSTING_PROHOSTING_CHK1PROLO_HOSTING_XTHOST_CHK1: 'PROLO_HOSTING_PROHOSTING_CHK1PROLO_HOSTING_XTHOST_CHK1',
    PROLO_LEO_M1: 'PROLO_LEO_M1',
    PROLO_PUBWEB_ITGEO_CHECK1: 'PROLO_PUBWEB_ITGEO_CHECK1',
    PROLO_PUBWEB_UKGEO_CHECK1: 'PROLO_PUBWEB_UKGEO_CHECK1',
    PROLO_PUBWEB_WWWGEO_CHECK1: 'PROLO_PUBWEB_WWWGEO_CHECK1',
    PROLO_REDIR_ZDNET_CHECK_1PUMPDUMP: 'PROLO_REDIR_ZDNET_CHECK_1PUMPDUMP',
    PUMPDUMP_MULTI: 'PUMPDUMP_MULTI',
    PUMPDUMP_TIP: 'PUMPDUMP_TIP',
    PYZOR_CHECK: 'PYZOR_CHECK',
    RAND_HEADER_LIST_SPOOF: 'RAND_HEADER_LIST_SPOOF',
    RAND_HEADER_MANY: 'RAND_HEADER_MANY',
    RAND_MKTG_HEADER: 'RAND_MKTG_HEADER',
    RATWARE_EFROM: 'RATWARE_EFROM',
    RATWARE_EGROUPSRATWARE_HASH_DASH: 'RATWARE_EGROUPSRATWARE_HASH_DASH',
    RATWARE_HELO_DM: 'RATWARE_HELO_DM',
    RATWARE_MOZ_MALFORMED: 'RATWARE_MOZ_MALFORMED',
    RATWARE_MPOP_WEBMAIL: 'RATWARE_MPOP_WEBMAIL',
    RATWARE_MS_HASH: 'RATWARE_MS_HASH',
    RATWARE_NAME_ID: 'RATWARE_NAME_ID',
    RATWARE_NO_RDNSRATWARE_OE_MALFORMED: 'RATWARE_NO_RDNSRATWARE_OE_MALFORMED',
    RATWARE_OUTLOOK_NONAME: 'RATWARE_OUTLOOK_NONAME',
    RATWARE_RCVD_AT: 'RATWARE_RCVD_AT',
    RATWARE_RCVD_PF: 'RATWARE_RCVD_PF',
    RATWARE_ZERO_TZ: 'RATWARE_ZERO_TZ',
    RAZOR2_CF_RANGE_51_100: 'RAZOR2_CF_RANGE_51_100',
    RAZOR2_CHECKRCD_RDNS_DYNAMIC_CLEAN: 'RAZOR2_CHECKRCD_RDNS_DYNAMIC_CLEAN',
    RCVD_AM_PM: 'RCVD_AM_PM',
    RCVD_BAD_ID: 'RCVD_BAD_ID',
    RCVD_BY_IP: 'RCVD_BY_IP',
    RCVD_DBL_DQ: 'RCVD_DBL_DQ',
    RCVD_DOTEDU_SHORT: 'RCVD_DOTEDU_SHORT',
    RCVD_DOTEDU_SUSP_URI: 'RCVD_DOTEDU_SUSP_URI',
    RCVD_DOUBLE_IP_LOOSERCVD_DOUBLE_IP_SPAM: 'RCVD_DOUBLE_IP_LOOSERCVD_DOUBLE_IP_SPAM',
    RCVD_FAKE_HELO_DOTCOM: 'RCVD_FAKE_HELO_DOTCOM',
    RCVD_FORGED_WROTE: 'RCVD_FORGED_WROTE',
    RCVD_FORGED_WROTE2: 'RCVD_FORGED_WROTE2',
    RCVD_FORGED_WROTE3: 'RCVD_FORGED_WROTE3',
    RCVD_FORGED_WROTE4: 'RCVD_FORGED_WROTE4',
    RCVD_HELO_IP_MISMATCHRCVD_ILLEGAL_IP: 'RCVD_HELO_IP_MISMATCHRCVD_ILLEGAL_IP',
    RCVD_IN_BL_SPAMCOP_NET: 'RCVD_IN_BL_SPAMCOP_NET',
    RCVD_IN_BRBL_LASTEXT: 'RCVD_IN_BRBL_LASTEXT',
    RCVD_IN_DNSWL_BLOCKED: 'RCVD_IN_DNSWL_BLOCKED',
    RCVD_IN_DNSWL_HI: 'RCVD_IN_DNSWL_HI',
    RCVD_IN_DNSWL_LOW: 'RCVD_IN_DNSWL_LOW',
    RCVD_IN_DNSWL_MEDRCVD_IN_DNSWL_NONE: 'RCVD_IN_DNSWL_MEDRCVD_IN_DNSWL_NONE',
    RCVD_IN_IADB_COURT: 'RCVD_IN_IADB_COURT',
    RCVD_IN_IADB_DK: 'RCVD_IN_IADB_DK',
    RCVD_IN_IADB_DMARC: 'RCVD_IN_IADB_DMARC',
    RCVD_IN_IADB_DOPTIN: 'RCVD_IN_IADB_DOPTIN',
    RCVD_IN_IADB_DOPTIN_GT50: 'RCVD_IN_IADB_DOPTIN_GT50',
    RCVD_IN_IADB_DOPTIN_LT50RCVD_IN_IADB_ECARD: 'RCVD_IN_IADB_DOPTIN_LT50RCVD_IN_IADB_ECARD',
    RCVD_IN_IADB_EDDB: 'RCVD_IN_IADB_EDDB',
    RCVD_IN_IADB_EPIA: 'RCVD_IN_IADB_EPIA',
    RCVD_IN_IADB_ESP: 'RCVD_IN_IADB_ESP',
    RCVD_IN_IADB_GOODMAIL: 'RCVD_IN_IADB_GOODMAIL',
    RCVD_IN_IADB_LEG_BNPROFIT: 'RCVD_IN_IADB_LEG_BNPROFIT',
    RCVD_IN_IADB_LEG_MANDRCVD_IN_IADB_LEG_NPROFIT: 'RCVD_IN_IADB_LEG_MANDRCVD_IN_IADB_LEG_NPROFIT',
    RCVD_IN_IADB_LISTED: 'RCVD_IN_IADB_LISTED',
    RCVD_IN_IADB_LOOSE: 'RCVD_IN_IADB_LOOSE',
    RCVD_IN_IADB_MI_CPEAR: 'RCVD_IN_IADB_MI_CPEAR',
    RCVD_IN_IADB_MI_CPR_30: 'RCVD_IN_IADB_MI_CPR_30',
    RCVD_IN_IADB_MI_CPR_MATRCVD_IN_IADB_ML_DOPTIN: 'RCVD_IN_IADB_MI_CPR_MATRCVD_IN_IADB_ML_DOPTIN',
    RCVD_IN_IADB_NOCONTROL: 'RCVD_IN_IADB_NOCONTROL',
    RCVD_IN_IADB_OOO: 'RCVD_IN_IADB_OOO',
    RCVD_IN_IADB_OPTIN: 'RCVD_IN_IADB_OPTIN',
    RCVD_IN_IADB_OPTIN_GT50: 'RCVD_IN_IADB_OPTIN_GT50',
    RCVD_IN_IADB_OPTIN_LT50RCVD_IN_IADB_OPTOUTONLY: 'RCVD_IN_IADB_OPTIN_LT50RCVD_IN_IADB_OPTOUTONLY',
    RCVD_IN_IADB_RDNS: 'RCVD_IN_IADB_RDNS',
    RCVD_IN_IADB_SENDERID: 'RCVD_IN_IADB_SENDERID',
    RCVD_IN_IADB_SOCIAL: 'RCVD_IN_IADB_SOCIAL',
    RCVD_IN_IADB_SPF: 'RCVD_IN_IADB_SPF',
    RCVD_IN_IADB_TRACK: 'RCVD_IN_IADB_TRACK',
    RCVD_IN_IADB_UNVERIFIED_1RCVD_IN_IADB_UNVERIFIED_2: 'RCVD_IN_IADB_UNVERIFIED_1RCVD_IN_IADB_UNVERIFIED_2',
    RCVD_IN_IADB_URG: 'RCVD_IN_IADB_URG',
    RCVD_IN_IADB_UT_CPEAR: 'RCVD_IN_IADB_UT_CPEAR',
    RCVD_IN_IADB_UT_CPR_30: 'RCVD_IN_IADB_UT_CPR_30',
    RCVD_IN_IADB_UT_CPR_MAT: 'RCVD_IN_IADB_UT_CPR_MAT',
    RCVD_IN_IADB_VOUCHEDRCVD_IN_MAPS_DUL: 'RCVD_IN_IADB_VOUCHEDRCVD_IN_MAPS_DUL',
    RCVD_IN_MAPS_NML: 'RCVD_IN_MAPS_NML',
    RCVD_IN_MAPS_OPS: 'RCVD_IN_MAPS_OPS',
    RCVD_IN_MAPS_RBL: 'RCVD_IN_MAPS_RBL',
    RCVD_IN_MAPS_RSS: 'RCVD_IN_MAPS_RSS',
    RCVD_IN_MSPIKE_BL: 'RCVD_IN_MSPIKE_BL',
    RCVD_IN_MSPIKE_H2RCVD_IN_MSPIKE_H3: 'RCVD_IN_MSPIKE_H2RCVD_IN_MSPIKE_H3',
    RCVD_IN_MSPIKE_H4: 'RCVD_IN_MSPIKE_H4',
    RCVD_IN_MSPIKE_H5: 'RCVD_IN_MSPIKE_H5',
    RCVD_IN_MSPIKE_L2: 'RCVD_IN_MSPIKE_L2',
    RCVD_IN_MSPIKE_L3: 'RCVD_IN_MSPIKE_L3',
    RCVD_IN_MSPIKE_L4: 'RCVD_IN_MSPIKE_L4',
    RCVD_IN_MSPIKE_L5RCVD_IN_MSPIKE_WL: 'RCVD_IN_MSPIKE_L5RCVD_IN_MSPIKE_WL',
    RCVD_IN_MSPIKE_ZBI: 'RCVD_IN_MSPIKE_ZBI',
    RCVD_IN_NJABL_CGI: 'RCVD_IN_NJABL_CGI',
    RCVD_IN_NJABL_DUL: 'RCVD_IN_NJABL_DUL',
    RCVD_IN_NJABL_MULTI: 'RCVD_IN_NJABL_MULTI',
    RCVD_IN_NJABL_PROXY: 'RCVD_IN_NJABL_PROXY',
    RCVD_IN_NJABL_SPAMRCVD_IN_PBL: 'RCVD_IN_NJABL_SPAMRCVD_IN_PBL',
    RCVD_IN_PSBL: 'RCVD_IN_PSBL',
    RCVD_IN_RPBLGOOD: 'RCVD_IN_RPBLGOOD',
    RCVD_IN_RPBLGREY: 'RCVD_IN_RPBLGREY',
    RCVD_IN_RP_CERTIFIED: 'RCVD_IN_RP_CERTIFIED',
    RCVD_IN_RP_RNBL: 'RCVD_IN_RP_RNBL',
    RCVD_IN_RP_SAFE: 'RCVD_IN_RP_SAFE',
    RCVD_IN_SBLRCVD_IN_SBL_CSS: 'RCVD_IN_SBLRCVD_IN_SBL_CSS',
    RCVD_IN_SORBS_BLOCK: 'RCVD_IN_SORBS_BLOCK',
    RCVD_IN_SORBS_DUL: 'RCVD_IN_SORBS_DUL',
    RCVD_IN_SORBS_HTTP: 'RCVD_IN_SORBS_HTTP',
    RCVD_IN_SORBS_SMTP: 'RCVD_IN_SORBS_SMTP',
    RCVD_IN_SORBS_SOCKS: 'RCVD_IN_SORBS_SOCKS',
    RCVD_IN_SORBS_WEBRCVD_IN_SORBS_ZOMBIE: 'RCVD_IN_SORBS_WEBRCVD_IN_SORBS_ZOMBIE',
    RCVD_IN_VALIDITY_CERTIFIED: 'RCVD_IN_VALIDITY_CERTIFIED',
    RCVD_IN_VALIDITY_CERTIFIED_BLOCKED: 'RCVD_IN_VALIDITY_CERTIFIED_BLOCKED',
    RCVD_IN_VALIDITY_RPBL: 'RCVD_IN_VALIDITY_RPBL',
    RCVD_IN_VALIDITY_RPBL_BLOCKEDRCVD_IN_VALIDITY_SAFE: 'RCVD_IN_VALIDITY_RPBL_BLOCKEDRCVD_IN_VALIDITY_SAFE',
    RCVD_IN_VALIDITY_SAFE_BLOCKED: 'RCVD_IN_VALIDITY_SAFE_BLOCKED',
    RCVD_IN_XBL: 'RCVD_IN_XBL',
    RCVD_IN_ZEN_BLOCKED: 'RCVD_IN_ZEN_BLOCKED',
    RCVD_IN_ZEN_BLOCKED_OPENDNS: 'RCVD_IN_ZEN_BLOCKED_OPENDNS',
    RCVD_MAIL_COMRCVD_NUMERIC_HELO: 'RCVD_MAIL_COMRCVD_NUMERIC_HELO',
    RDNS_DYNAMIC: 'RDNS_DYNAMIC',
    RDNS_LOCALHOST: 'RDNS_LOCALHOST',
    RDNS_NONE: 'RDNS_NONE',
    RDNS_NUM_TLD_ATCHNX: 'RDNS_NUM_TLD_ATCHNX',
    RDNS_NUM_TLD_XM: 'RDNS_NUM_TLD_XM',
    REFINANCE_NOW: 'REFINANCE_NOW',
    REFINANCE_YOUR_HOMERELAYCOUNTRY_CN: 'REFINANCE_YOUR_HOMERELAYCOUNTRY_CN',
    RELAYCOUNTRY_RU: 'RELAYCOUNTRY_RU',
    RELAYCOUNTRY_UA: 'RELAYCOUNTRY_UA',
    REMOTE_IMAGE: 'REMOTE_IMAGE',
    REMOVE_BEFORE_LINK: 'REMOVE_BEFORE_LINK',
    REPLICA_WATCH: 'REPLICA_WATCH',
    REPLYTO_EMPTY: 'REPLYTO_EMPTY',
    REPLYTO_WITHOUT_TO_CCREPTO_419_FRAUD: 'REPLYTO_WITHOUT_TO_CCREPTO_419_FRAUD',
    REPTO_419_FRAUD_AOL: 'REPTO_419_FRAUD_AOL',
    REPTO_419_FRAUD_AOL_LOOSE: 'REPTO_419_FRAUD_AOL_LOOSE',
    REPTO_419_FRAUD_CNS: 'REPTO_419_FRAUD_CNS',
    REPTO_419_FRAUD_GM: 'REPTO_419_FRAUD_GM',
    REPTO_419_FRAUD_GM_LOOSEREPTO_419_FRAUD_HM: 'REPTO_419_FRAUD_GM_LOOSEREPTO_419_FRAUD_HM',
    REPTO_419_FRAUD_OL: 'REPTO_419_FRAUD_OL',
    REPTO_419_FRAUD_PM: 'REPTO_419_FRAUD_PM',
    REPTO_419_FRAUD_QQ: 'REPTO_419_FRAUD_QQ',
    REPTO_419_FRAUD_YH: 'REPTO_419_FRAUD_YH',
    REPTO_419_FRAUD_YH_LOOSE: 'REPTO_419_FRAUD_YH_LOOSE',
    REPTO_419_FRAUD_YJREPTO_419_FRAUD_YN: 'REPTO_419_FRAUD_YJREPTO_419_FRAUD_YN',
    REPTO_QUOTE_AOL: 'REPTO_QUOTE_AOL',
    REPTO_QUOTE_IMS: 'REPTO_QUOTE_IMS',
    REPTO_QUOTE_MSN: 'REPTO_QUOTE_MSN',
    REPTO_QUOTE_QUALCOMM: 'REPTO_QUOTE_QUALCOMM',
    REPTO_QUOTE_YAHOO: 'REPTO_QUOTE_YAHOO',
    RISK_FREE: 'RISK_FREE',
    RPT_SPAM_HDRRP_D_00086: 'RPT_SPAM_HDRRP_D_00086',
    RP_MATCHES_RCVD: 'RP_MATCHES_RCVD',
    RP_ZIP_ECTYP: 'RP_ZIP_ECTYP',
    RUDE_HTML: 'RUDE_HTML',
    RUNON_SHY: 'RUNON_SHY',
    S25R: 'S25R',
    S25R_1: 'S25R_1',
    S25R_2: 'S25R_2',
    S25R_3: 'S25R_3',
    S25R_5: 'S25R_5',
    S25R_6: 'S25R_6',
    SB_GIF_AND_NO_URIS: 'SB_GIF_AND_NO_URIS',
    SCANNED_EXTERNALSCC_BOGUS_CTE_1: 'SCANNED_EXTERNALSCC_BOGUS_CTE_1',
    SCC_CANSPAM_2: 'SCC_CANSPAM_2',
    SCC_FAKE_CPANEL: 'SCC_FAKE_CPANEL',
    SCC_ISEMM_LID_1: 'SCC_ISEMM_LID_1',
    SCC_ISEMM_LID_1A: 'SCC_ISEMM_LID_1A',
    SCC_ISEMM_LID_1B: 'SCC_ISEMM_LID_1B',
    SCC_NEWBIE_HASBEENS: 'SCC_NEWBIE_HASBEENS',
    SCC_SPAMMER_ADDR_2SCC_SPECIAL_GUID: 'SCC_SPAMMER_ADDR_2SCC_SPECIAL_GUID',
    SCRIPT_GIBBERISH: 'SCRIPT_GIBBERISH',
    SENDGRID_REDIR: 'SENDGRID_REDIR',
    SENDGRID_REDIR_PHISH: 'SENDGRID_REDIR_PHISH',
    SEO_SUSP_NTLD: 'SEO_SUSP_NTLD',
    SERGIO_SUBJECT_PORN002: 'SERGIO_SUBJECT_PORN002',
    SERGIO_SUBJECT_PORN003SERGIO_SUBJECT_PORN004: 'SERGIO_SUBJECT_PORN003SERGIO_SUBJECT_PORN004',
    SERGIO_SUBJECT_PORN005: 'SERGIO_SUBJECT_PORN005',
    SERGIO_SUBJECT_PORN006: 'SERGIO_SUBJECT_PORN006',
    SERGIO_SUBJECT_PORN007: 'SERGIO_SUBJECT_PORN007',
    SERGIO_SUBJECT_PORN008: 'SERGIO_SUBJECT_PORN008',
    SERGIO_SUBJECT_PORN009SERGIO_SUBJECT_PORN010: 'SERGIO_SUBJECT_PORN009SERGIO_SUBJECT_PORN010',
    SERGIO_SUBJECT_PORN011: 'SERGIO_SUBJECT_PORN011',
    SERGIO_SUBJECT_PORN012: 'SERGIO_SUBJECT_PORN012',
    SERGIO_SUBJECT_PORN013: 'SERGIO_SUBJECT_PORN013',
    SERGIO_SUBJECT_PORN015: 'SERGIO_SUBJECT_PORN015',
    SERGIO_SUBJECT_VIAGRA01SHARE_50_50: 'SERGIO_SUBJECT_VIAGRA01SHARE_50_50',
    SHOPIFY_IMG_NOT_RCVD_SFY: 'SHOPIFY_IMG_NOT_RCVD_SFY',
    SHORTCIRCUIT: 'SHORTCIRCUIT',
    SHORTENED_URL_HREF: 'SHORTENED_URL_HREF',
    SHORTENED_URL_SRC: 'SHORTENED_URL_SRC',
    SHORTENER_SHORT_IMG: 'SHORTENER_SHORT_IMG',
    SHORT_HELO_AND_INLINE_IMAGESHORT_IMG_SUSP_NTLD: 'SHORT_HELO_AND_INLINE_IMAGESHORT_IMG_SUSP_NTLD',
    SHORT_TERM_PRICE: 'SHORT_TERM_PRICE',
    SHORT_URL: 'SHORT_URL',
    SHY_OBFU_EXPIRE: 'SHY_OBFU_EXPIRE',
    SHY_OBFU_PASSWORD: 'SHY_OBFU_PASSWORD',
    SMF_FM_FORGED_REPLYTO: 'SMF_FM_FORGED_REPLYTO',
    SOLICIT_BIZ: 'SOLICIT_BIZ',
    SORTED_RECIPSSPAMMY_MIME_BDRY_01: 'SORTED_RECIPSSPAMMY_MIME_BDRY_01',
    SPAMMY_XMAILER: 'SPAMMY_XMAILER',
    SPELLED_OUT_NUMBER: 'SPELLED_OUT_NUMBER',
    SPF_FAIL: 'SPF_FAIL',
    SPF_HELO_FAIL: 'SPF_HELO_FAIL',
    SPF_HELO_NEUTRAL: 'SPF_HELO_NEUTRAL',
    SPF_HELO_NONE: 'SPF_HELO_NONE',
    SPF_HELO_PASSSPF_HELO_SOFTFAIL: 'SPF_HELO_PASSSPF_HELO_SOFTFAIL',
    SPF_NEUTRAL: 'SPF_NEUTRAL',
    SPF_NONE: 'SPF_NONE',
    SPF_PASS: 'SPF_PASS',
    SPF_SOFTFAIL: 'SPF_SOFTFAIL',
    SPOOFED_FREEMAIL: 'SPOOFED_FREEMAIL',
    SPOOFED_FREEMAIL_NO_RDNS: 'SPOOFED_FREEMAIL_NO_RDNS',
    SPOOFED_FREEM_REPTOSPOOFED_FREEM_REPTO_CHN: 'SPOOFED_FREEM_REPTOSPOOFED_FREEM_REPTO_CHN',
    SPOOFED_FREEM_REPTO_RUS: 'SPOOFED_FREEM_REPTO_RUS',
    SPOOFED_URL: 'SPOOFED_URL',
    SPOOFED_URL_HOST: 'SPOOFED_URL_HOST',
    SPOOF_COM2COM: 'SPOOF_COM2COM',
    SPOOF_COM2OTH: 'SPOOF_COM2OTH',
    SPOOF_GMAIL_MIDSPOOF_NET2COM: 'SPOOF_GMAIL_MIDSPOOF_NET2COM',
    STATIC_XPRIO_OLE: 'STATIC_XPRIO_OLE',
    STOCK_ALERT: 'STOCK_ALERT',
    STOCK_IMG_CTYPE: 'STOCK_IMG_CTYPE',
    STOCK_IMG_HDR_FROM: 'STOCK_IMG_HDR_FROM',
    STOCK_IMG_HTML: 'STOCK_IMG_HTML',
    STOCK_IMG_OUTLOOK: 'STOCK_IMG_OUTLOOK',
    STOCK_PRICESSTOCK_TIP: 'STOCK_PRICESSTOCK_TIP',
    STOX_AND_PRICE: 'STOX_AND_PRICE',
    STOX_BOUND_090909_B: 'STOX_BOUND_090909_B',
    STOX_META_5: 'STOX_META_5',
    STOX_REPLY_TYPE: 'STOX_REPLY_TYPE',
    STOX_REPLY_TYPE_WITHOUT_QUOTES: 'STOX_REPLY_TYPE_WITHOUT_QUOTES',
    STOX_UA: 'STOX_UA',
    STRONG_BUYSTUDDLYCAPS: 'STRONG_BUYSTUDDLYCAPS',
    SUBJECT_DIET: 'SUBJECT_DIET',
    SUBJECT_DRUG_GAP_C: 'SUBJECT_DRUG_GAP_C',
    SUBJECT_DRUG_GAP_L: 'SUBJECT_DRUG_GAP_L',
    SUBJECT_DRUG_GAP_S: 'SUBJECT_DRUG_GAP_S',
    SUBJECT_DRUG_GAP_VA: 'SUBJECT_DRUG_GAP_VA',
    SUBJECT_DRUG_GAP_XSUBJECT_FUZZY_CHEAP: 'SUBJECT_DRUG_GAP_XSUBJECT_FUZZY_CHEAP',
    SUBJECT_FUZZY_MEDS: 'SUBJECT_FUZZY_MEDS',
    SUBJECT_FUZZY_PENIS: 'SUBJECT_FUZZY_PENIS',
    SUBJECT_FUZZY_TION: 'SUBJECT_FUZZY_TION',
    SUBJECT_FUZZY_VPILL: 'SUBJECT_FUZZY_VPILL',
    SUBJECT_IN_BLACKLIST: 'SUBJECT_IN_BLACKLIST',
    SUBJECT_IN_BLOCKLISTSUBJECT_IN_WELCOMELIST: 'SUBJECT_IN_BLOCKLISTSUBJECT_IN_WELCOMELIST',
    SUBJECT_IN_WHITELIST: 'SUBJECT_IN_WHITELIST',
    SUBJECT_NEEDS_ENCODING: 'SUBJECT_NEEDS_ENCODING',
    SUBJECT_SEXUAL: 'SUBJECT_SEXUAL',
    SUBJ_ALL_CAPS: 'SUBJ_ALL_CAPS',
    SUBJ_AS_SEEN: 'SUBJ_AS_SEEN',
    SUBJ_ATTENTIONSUBJ_BRKN_WORDNUMS: 'SUBJ_ATTENTIONSUBJ_BRKN_WORDNUMS',
    SUBJ_BROKEN_WORD: 'SUBJ_BROKEN_WORD',
    SUBJ_BROKEN_WORDS: 'SUBJ_BROKEN_WORDS',
    SUBJ_BUY: 'SUBJ_BUY',
    SUBJ_DOLLARS: 'SUBJ_DOLLARS',
    SUBJ_ILLEGAL_CHARS: 'SUBJ_ILLEGAL_CHARS',
    SUBJ_LACKS_WORDS: 'SUBJ_LACKS_WORDS',
    SUBJ_OBFU_LOW_CNTRSTSUBJ_OBFU_PUNCT_FEW: 'SUBJ_OBFU_LOW_CNTRSTSUBJ_OBFU_PUNCT_FEW',
    SUBJ_OBFU_PUNCT_MANY: 'SUBJ_OBFU_PUNCT_MANY',
    SUBJ_ODD_CASE: 'SUBJ_ODD_CASE',
    SUBJ_RE_CLNCLN: 'SUBJ_RE_CLNCLN',
    SUBJ_RND_UC_CHAR: 'SUBJ_RND_UC_CHAR',
    SUBJ_RND_UC_CHAR_L: 'SUBJ_RND_UC_CHAR_L',
    SUBJ_UNNEEDED_HTMLSUBJ_YOUR_FAMILY: 'SUBJ_UNNEEDED_HTMLSUBJ_YOUR_FAMILY',
    SURBL_BLOCKED: 'SURBL_BLOCKED',
    SUSPICIOUS_RECIPS: 'SUSPICIOUS_RECIPS',
    SUSP_UTF8_WORD_COMBO: 'SUSP_UTF8_WORD_COMBO',
    SUSP_UTF8_WORD_FROM: 'SUSP_UTF8_WORD_FROM',
    SUSP_UTF8_WORD_SUBJ: 'SUSP_UTF8_WORD_SUBJ',
    SYSADMIN: 'SYSADMIN',
    TAB_IN_FROMTAGSTAT_IMG_NOT_RCVD_TGST: 'TAB_IN_FROMTAGSTAT_IMG_NOT_RCVD_TGST',
    TARINGANET_IMG_NOT_RCVD_TN: 'TARINGANET_IMG_NOT_RCVD_TN',
    TBIRD_SUSP_MIME_BDRY: 'TBIRD_SUSP_MIME_BDRY',
    TEMPLATE_203_RCVD: 'TEMPLATE_203_RCVD',
    TEQF_USR_IMAGE: 'TEQF_USR_IMAGE',
    TEQF_USR_MSGID_HEXTEQF_USR_MSGID_MALF: 'TEQF_USR_MSGID_HEXTEQF_USR_MSGID_MALF',
    TEQF_USR_POLITE: 'TEQF_USR_POLITE',
    THEBAT_UNREG: 'THEBAT_UNREG',
    THIS_AD: 'THIS_AD',
    THIS_IS_ADV_SUSP_NTLD: 'THIS_IS_ADV_SUSP_NTLD',
    TINY_FLOAT: 'TINY_FLOAT',
    TONLINE_FAKE_DKIM: 'TONLINE_FAKE_DKIM',
    TO_EQ_FM_DIRECT_MXTO_EQ_FM_DOM_HTML_IMG: 'TO_EQ_FM_DIRECT_MXTO_EQ_FM_DOM_HTML_IMG',
    TO_EQ_FM_DOM_HTML_ONLY: 'TO_EQ_FM_DOM_HTML_ONLY',
    TO_EQ_FM_DOM_SPF_FAIL: 'TO_EQ_FM_DOM_SPF_FAIL',
    TO_EQ_FM_HTML_DIRECT: 'TO_EQ_FM_HTML_DIRECT',
    TO_EQ_FM_HTML_ONLY: 'TO_EQ_FM_HTML_ONLY',
    TO_EQ_FM_SPF_FAILTO_IN_SUBJ: 'TO_EQ_FM_SPF_FAILTO_IN_SUBJ',
    TO_JOHNZY: 'TO_JOHNZY',
    TO_MALFORMED: 'TO_MALFORMED',
    TO_NAME_SUBJ_NO_RDNS: 'TO_NAME_SUBJ_NO_RDNS',
    TO_NO_BRKTS_FREEMAIL: 'TO_NO_BRKTS_FREEMAIL',
    TO_NO_BRKTS_FROM_MSSP: 'TO_NO_BRKTS_FROM_MSSP',
    TO_NO_BRKTS_HTML_IMG: 'TO_NO_BRKTS_HTML_IMG',
    TO_NO_BRKTS_HTML_ONLYTO_NO_BRKTS_MSFT: 'TO_NO_BRKTS_HTML_ONLYTO_NO_BRKTS_MSFT',
    TO_NO_BRKTS_NORDNS: 'TO_NO_BRKTS_NORDNS',
    TO_NO_BRKTS_NORDNS_HTML: 'TO_NO_BRKTS_NORDNS_HTML',
    TO_NO_BRKTS_PCNT: 'TO_NO_BRKTS_PCNT',
    TO_ONE_CHAR: 'TO_ONE_CHAR',
    TO_SEM_SEM: 'TO_SEM_SEM',
    TO_TOO_MANY_WFH_01: 'TO_TOO_MANY_WFH_01',
    TRACKER_IDTR_FILLER_TEXT: 'TRACKER_IDTR_FILLER_TEXT',
    TR_JS_FROMCHARCODE: 'TR_JS_FROMCHARCODE',
    TR_JS_REDIRECTION_0: 'TR_JS_REDIRECTION_0',
    TR_JS_REDIRECTION_1: 'TR_JS_REDIRECTION_1',
    TR_JS_REDIRECTION_2: 'TR_JS_REDIRECTION_2',
    TT_MSGID_TRUNC: 'TT_MSGID_TRUNC',
    TT_OBSCURED_VALIUMTT_OBSCURED_VIAGRA: 'TT_OBSCURED_VALIUMTT_OBSCURED_VIAGRA',
    TT_OBSCURED_XANAX: 'TT_OBSCURED_XANAX',
    TVD_ACT_193: 'TVD_ACT_193',
    TVD_APPROVED: 'TVD_APPROVED',
    TVD_DEAR_HOMEOWNER: 'TVD_DEAR_HOMEOWNER',
    TVD_EB_PHISH: 'TVD_EB_PHISH',
    TVD_ENVFROM_APOST: 'TVD_ENVFROM_APOST',
    TVD_FINGER_02TVD_FLOAT_GENERAL: 'TVD_FINGER_02TVD_FLOAT_GENERAL',
    TVD_FUZZY_DEGREE: 'TVD_FUZZY_DEGREE',
    TVD_FUZZY_FINANCE: 'TVD_FUZZY_FINANCE',
    TVD_FUZZY_FIXED_RATE: 'TVD_FUZZY_FIXED_RATE',
    TVD_FUZZY_MICROCAP: 'TVD_FUZZY_MICROCAP',
    TVD_FUZZY_PHARMACEUTICAL: 'TVD_FUZZY_PHARMACEUTICAL',
    TVD_FUZZY_SYMBOLTVD_FW_GRAPHIC_NAME_LONG: 'TVD_FUZZY_SYMBOLTVD_FW_GRAPHIC_NAME_LONG',
    TVD_FW_GRAPHIC_NAME_MID: 'TVD_FW_GRAPHIC_NAME_MID',
    TVD_INCREASE_SIZE: 'TVD_INCREASE_SIZE',
    TVD_LINK_SAVE: 'TVD_LINK_SAVE',
    TVD_PH_1: 'TVD_PH_1',
    TVD_PH_7: 'TVD_PH_7',
    TVD_PH_BODY_ACCOUNTS_PRETVD_PH_REC: 'TVD_PH_BODY_ACCOUNTS_PRETVD_PH_REC',
    TVD_PH_SEC: 'TVD_PH_SEC',
    TVD_PP_PHISH: 'TVD_PP_PHISH',
    TVD_QUAL_MEDS: 'TVD_QUAL_MEDS',
    TVD_RATWARE_CB: 'TVD_RATWARE_CB',
    TVD_RATWARE_CB_2: 'TVD_RATWARE_CB_2',
    TVD_RATWARE_MSGID_02: 'TVD_RATWARE_MSGID_02',
    TVD_RCVD_IP: 'TVD_RCVD_IP',
    TVD_RCVD_IP4TVD_RCVD_SINGLE: 'TVD_RCVD_IP4TVD_RCVD_SINGLE',
    TVD_RCVD_SPACE_BRACKET: 'TVD_RCVD_SPACE_BRACKET',
    TVD_SECTION: 'TVD_SECTION',
    TVD_SILLY_URI_OBFU: 'TVD_SILLY_URI_OBFU',
    TVD_SPACED_SUBJECT_WORD3: 'TVD_SPACED_SUBJECT_WORD3',
    TVD_SPACE_RATIO: 'TVD_SPACE_RATIO',
    TVD_SPACE_RATIO_MINFPTVD_STOCK1: 'TVD_SPACE_RATIO_MINFPTVD_STOCK1',
    TVD_SUBJ_ACC_NUM: 'TVD_SUBJ_ACC_NUM',
    TVD_SUBJ_FINGER_03: 'TVD_SUBJ_FINGER_03',
    TVD_SUBJ_NUM_OBFU_MINFP: 'TVD_SUBJ_NUM_OBFU_MINFP',
    TVD_SUBJ_OWE: 'TVD_SUBJ_OWE',
    TVD_SUBJ_WIPE_DEBT: 'TVD_SUBJ_WIPE_DEBT',
    TVD_VISIT_PHARMA: 'TVD_VISIT_PHARMA',
    TVD_VIS_HIDDENTW_GIBBERISH_MANY: 'TVD_VIS_HIDDENTW_GIBBERISH_MANY',
    T_ACH_CANCELLED_EXE: 'T_ACH_CANCELLED_EXE',
    T_ANY_PILL_PRICE: 'T_ANY_PILL_PRICE',
    T_BODY_QUOTE_MALF_MSGID: 'T_BODY_QUOTE_MALF_MSGID',
    T_CDISP_SZ_MANY: 'T_CDISP_SZ_MANY',
    T_COMPENSATION: 'T_COMPENSATION',
    T_CTE_BAS64T_CTYPE_NULL: 'T_CTE_BAS64T_CTYPE_NULL',
    T_DATE_IN_FUTURE_96_Q: 'T_DATE_IN_FUTURE_96_Q',
    T_DATE_IN_FUTURE_Q_PLUS: 'T_DATE_IN_FUTURE_Q_PLUS',
    T_DOC_ATTACH_NO_EXT: 'T_DOC_ATTACH_NO_EXT',
    T_DOS_OUTLOOK_TO_MX_IMAGE: 'T_DOS_OUTLOOK_TO_MX_IMAGE',
    T_DOS_ZIP_HARDCORET_DRUGS_ERECTILE_SHORT_SHORTNER: 'T_DOS_ZIP_HARDCORET_DRUGS_ERECTILE_SHORT_SHORTNER',
    T_FILL_THIS_FORM_FRAUD_PHISH: 'T_FILL_THIS_FORM_FRAUD_PHISH',
    T_FILL_THIS_FORM_LOAN: 'T_FILL_THIS_FORM_LOAN',
    T_FILL_THIS_FORM_SHORT: 'T_FILL_THIS_FORM_SHORT',
    T_FORGED_TBIRD_IMG_SIZET_FREEMAIL_DOC_PDF: 'T_FORGED_TBIRD_IMG_SIZET_FREEMAIL_DOC_PDF',
    T_FREEMAIL_DOC_PDF_BCC: 'T_FREEMAIL_DOC_PDF_BCC',
    T_FREEMAIL_RVW_ATTCH: 'T_FREEMAIL_RVW_ATTCH',
    T_FROM_2_EMAILS_SHORT: 'T_FROM_2_EMAILS_SHORT',
    T_FROM_MULTI_SHORT_IMG: 'T_FROM_MULTI_SHORT_IMG',
    T_FROM_NAME_EQ_TO_G_DRIVET_FUZZY_OPTOUT: 'T_FROM_NAME_EQ_TO_G_DRIVET_FUZZY_OPTOUT',
    T_FUZZY_SPRM: 'T_FUZZY_SPRM',
    T_GB_WEBFORM: 'T_GB_WEBFORM',
    T_GOOGLE_DRIVE_DEAR_SOMETHING: 'T_GOOGLE_DRIVE_DEAR_SOMETHING',
    T_HDRS_LCASE: 'T_HDRS_LCASE',
    T_HK_NAME_FM_FROM: 'T_HK_NAME_FM_FROM',
    T_HK_NAME_FROM: 'T_HK_NAME_FROM',
    T_HK_SPAMMY_FILENAMET_HTML_ATTACH: 'T_HK_SPAMMY_FILENAMET_HTML_ATTACH',
    T_ISO_ATTACH: 'T_ISO_ATTACH',
    T_KAM_HTML_FONT_INVALID: 'T_KAM_HTML_FONT_INVALID',
    T_LARGE_PCT_AFTER_MANY: 'T_LARGE_PCT_AFTER_MANY',
    T_LFUZ_PWRMALE: 'T_LFUZ_PWRMALE',
    T_LOTTO_AGENT_FM: 'T_LOTTO_AGENT_FM',
    T_LOTTO_AGENT_RPLYT_LOTTO_URI: 'T_LOTTO_AGENT_RPLYT_LOTTO_URI',
    T_MANY_HDRS_LCASE: 'T_MANY_HDRS_LCASE',
    T_MANY_PILL_PRICE: 'T_MANY_PILL_PRICE',
    T_MIME_MALF: 'T_MIME_MALF',
    T_MONEY_PERCENT: 'T_MONEY_PERCENT',
    T_OBFU_ATTACH_MISSP: 'T_OBFU_ATTACH_MISSP',
    T_OBFU_DOC_ATTACH: 'T_OBFU_DOC_ATTACH',
    T_OBFU_GIF_ATTACHT_OBFU_HTML_ATTACH: 'T_OBFU_GIF_ATTACHT_OBFU_HTML_ATTACH',
    T_OBFU_HTML_ATT_MALW: 'T_OBFU_HTML_ATT_MALW',
    T_OBFU_JPG_ATTACH: 'T_OBFU_JPG_ATTACH',
    T_OBFU_PDF_ATTACH: 'T_OBFU_PDF_ATTACH',
    T_OFFER_ONLY_AMERICA: 'T_OFFER_ONLY_AMERICA',
    T_PDS_BTC_AHACKER: 'T_PDS_BTC_AHACKER',
    T_PDS_BTC_HACKERT_PDS_BTC_NTLD: 'T_PDS_BTC_HACKERT_PDS_BTC_NTLD',
    T_PDS_DBL_URL_ILLEGAL_CHARS: 'T_PDS_DBL_URL_ILLEGAL_CHARS',
    T_PDS_DBL_URL_TNB_RUNON: 'T_PDS_DBL_URL_TNB_RUNON',
    T_PDS_DOUBLE_URL: 'T_PDS_DOUBLE_URL',
    T_PDS_EMPTYSUBJ_URISHRT: 'T_PDS_EMPTYSUBJ_URISHRT',
    T_PDS_FREEMAIL_REPLYTO_URISHRTT_PDS_FROM_2_EMAILS_SHRTNER: 'T_PDS_FREEMAIL_REPLYTO_URISHRTT_PDS_FROM_2_EMAILS_SHRTNER',
    T_PDS_HIDDEN_UK_BUSINESSLOAN: 'T_PDS_HIDDEN_UK_BUSINESSLOAN',
    T_PDS_LITECOIN_ID: 'T_PDS_LITECOIN_ID',
    T_PDS_LTC_AHACKER: 'T_PDS_LTC_AHACKER',
    T_PDS_LTC_HACKER: 'T_PDS_LTC_HACKER',
    T_PDS_NO_FULL_NAME_SPOOFED_URLT_PDS_PRO_TLD: 'T_PDS_NO_FULL_NAME_SPOOFED_URLT_PDS_PRO_TLD',
    T_PDS_SHORTFWD_URISHRT: 'T_PDS_SHORTFWD_URISHRT',
    T_PDS_SHORTFWD_URISHRT_FP: 'T_PDS_SHORTFWD_URISHRT_FP',
    T_PDS_SHORTFWD_URISHRT_QP: 'T_PDS_SHORTFWD_URISHRT_QP',
    T_PDS_SHORT_SPOOFED_URL: 'T_PDS_SHORT_SPOOFED_URL',
    T_PDS_TINYSUBJ_URISHRTT_PDS_TONAME_EQ_TOLOCAL_FREEM_FORGE: 'T_PDS_TINYSUBJ_URISHRTT_PDS_TONAME_EQ_TOLOCAL_FREEM_FORGE',
    T_PDS_TONAME_EQ_TOLOCAL_HDRS_LCASE: 'T_PDS_TONAME_EQ_TOLOCAL_HDRS_LCASE',
    T_PDS_TONAME_EQ_TOLOCAL_SHORT: 'T_PDS_TONAME_EQ_TOLOCAL_SHORT',
    T_PDS_TONAME_EQ_TOLOCAL_VSHORTT_PDS_TO_EQ_FROM_NAME: 'T_PDS_TONAME_EQ_TOLOCAL_VSHORTT_PDS_TO_EQ_FROM_NAME',
    T_PDS_URISHRT_LOCALPART_SUBJ: 'T_PDS_URISHRT_LOCALPART_SUBJ',
    T_PDS_URI_HIDDEN_HELO_NO_DOMAIN: 'T_PDS_URI_HIDDEN_HELO_NO_DOMAIN',
    T_PHOTO_EDITING_DIRECT: 'T_PHOTO_EDITING_DIRECT',
    T_PHOTO_EDITING_FREEMT_REMOTE_IMAGE: 'T_PHOTO_EDITING_FREEMT_REMOTE_IMAGE',
    T_SCC_CTMPP: 'T_SCC_CTMPP',
    T_SENT_TO_EMAIL_ADDR: 'T_SENT_TO_EMAIL_ADDR',
    T_SHARE_50_50: 'T_SHARE_50_50',
    T_SHORT_BODY_G_DRIVE_DYN: 'T_SHORT_BODY_G_DRIVE_DYN',
    T_SHORT_BODY_QUOTE: 'T_SHORT_BODY_QUOTE',
    T_SHORT_SHORTNERT_SPF_HELO_PERMERROR: 'T_SHORT_SHORTNERT_SPF_HELO_PERMERROR',
    T_SPF_HELO_TEMPERROR: 'T_SPF_HELO_TEMPERROR',
    T_SPF_PERMERROR: 'T_SPF_PERMERROR',
    T_SPF_TEMPERROR: 'T_SPF_TEMPERROR',
    T_STY_INVIS_DIRECT: 'T_STY_INVIS_DIRECT',
    T_SUSPNTLD_EXPIRATION_EXTORTT_TONOM_EQ_TOLOC_SHRT_PSHRTNER: 'T_SUSPNTLD_EXPIRATION_EXTORTT_TONOM_EQ_TOLOC_SHRT_PSHRTNER',
    T_TONOM_EQ_TOLOC_SHRT_SHRTNER: 'T_TONOM_EQ_TOLOC_SHRT_SHRTNER',
    T_TVD_FUZZY_SECTOR: 'T_TVD_FUZZY_SECTOR',
    T_TVD_FUZZY_SECURITIES: 'T_TVD_FUZZY_SECURITIES',
    T_TVD_FW_GRAPHIC_ID2T_TVD_MIME_EPI: 'T_TVD_FW_GRAPHIC_ID2T_TVD_MIME_EPI',
    T_TVD_MIME_NO_HEADERS: 'T_TVD_MIME_NO_HEADERS',
    T_URI_GOOG_STO_SUBD_SPAMMY: 'T_URI_GOOG_STO_SUBD_SPAMMY',
    T_WON_MONEY_ATTACH: 'T_WON_MONEY_ATTACH',
    T_WON_NBDY_ATTACH: 'T_WON_NBDY_ATTACH',
    T_XPRIO_URL_SHORTNERT_ZW_OBFU_BITCOIN: 'T_XPRIO_URL_SHORTNERT_ZW_OBFU_BITCOIN',
    T_ZW_OBFU_FREEM: 'T_ZW_OBFU_FREEM',
    T_ZW_OBFU_FROMTOSUBJ: 'T_ZW_OBFU_FROMTOSUBJ',
    UAH_VIAGRA_IMAGE: 'UAH_VIAGRA_IMAGE',
    UC_GIBBERISH_OBFU: 'UC_GIBBERISH_OBFU',
    UNCLAIMED_MONEY: 'UNCLAIMED_MONEY',
    UNCLOSED_BRACKETUNDISC_FREEM: 'UNCLOSED_BRACKETUNDISC_FREEM',
    UNDISC_MONEY: 'UNDISC_MONEY',
    UNICODE_OBFU_ASC: 'UNICODE_OBFU_ASC',
    UNICODE_OBFU_ZW: 'UNICODE_OBFU_ZW',
    UNICODE_OBFU_ZW_MANY: 'UNICODE_OBFU_ZW_MANY',
    UNICODE_RTL_OBFU: 'UNICODE_RTL_OBFU',
    UNPARSEABLE_RELAY: 'UNPARSEABLE_RELAY',
    UNRESOLVED_TEMPLATEUNSUBSCRIBE_ES: 'UNRESOLVED_TEMPLATEUNSUBSCRIBE_ES',
    UNSUBSCRIBE_PT: 'UNSUBSCRIBE_PT',
    UNSUB_GOOG_FORM: 'UNSUB_GOOG_FORM',
    UN_NO_ML: 'UN_NO_ML',
    UPGRADE_MAILBOX: 'UPGRADE_MAILBOX',
    UPPERCASE_50_75: 'UPPERCASE_50_75',
    UPPERCASE_75_100: 'UPPERCASE_75_100',
    UPPERCASE_URI: 'UPPERCASE_URI',
    URG_BIZURIBL_ABUSE_SURBL: 'URG_BIZURIBL_ABUSE_SURBL',
    URIBL_AB_SURBL: 'URIBL_AB_SURBL',
    URIBL_BESO: 'URIBL_BESO',
    URIBL_BLACK: 'URIBL_BLACK',
    URIBL_BLOCKED: 'URIBL_BLOCKED',
    URIBL_CR_SURBL: 'URIBL_CR_SURBL',
    URIBL_CSS: 'URIBL_CSS',
    URIBL_CSS_A: 'URIBL_CSS_A',
    URIBL_CT_SURBLURIBL_DBL_ABUSE_BOTCC: 'URIBL_CT_SURBLURIBL_DBL_ABUSE_BOTCC',
    URIBL_DBL_ABUSE_MALW: 'URIBL_DBL_ABUSE_MALW',
    URIBL_DBL_ABUSE_PHISH: 'URIBL_DBL_ABUSE_PHISH',
    URIBL_DBL_ABUSE_REDIR: 'URIBL_DBL_ABUSE_REDIR',
    URIBL_DBL_ABUSE_SPAM: 'URIBL_DBL_ABUSE_SPAM',
    URIBL_DBL_BLOCKEDURIBL_DBL_BLOCKED_OPENDNS: 'URIBL_DBL_BLOCKEDURIBL_DBL_BLOCKED_OPENDNS',
    URIBL_DBL_BOTNETCC: 'URIBL_DBL_BOTNETCC',
    URIBL_DBL_ERROR: 'URIBL_DBL_ERROR',
    URIBL_DBL_MALWARE: 'URIBL_DBL_MALWARE',
    URIBL_DBL_PHISH: 'URIBL_DBL_PHISH',
    URIBL_DBL_SPAM: 'URIBL_DBL_SPAM',
    URIBL_DM_SURBLURIBL_GREY: 'URIBL_DM_SURBLURIBL_GREY',
    URIBL_MW_SURBL: 'URIBL_MW_SURBL',
    URIBL_PH_SURBL: 'URIBL_PH_SURBL',
    URIBL_RED: 'URIBL_RED',
    URIBL_RHS_ABUSE: 'URIBL_RHS_ABUSE',
    URIBL_RHS_BOGUSMX: 'URIBL_RHS_BOGUSMX',
    URIBL_RHS_DOB: 'URIBL_RHS_DOB',
    URIBL_RHS_DSN: 'URIBL_RHS_DSN',
    URIBL_RHS_POSTURIBL_RHS_TLD_WHOIS: 'URIBL_RHS_POSTURIBL_RHS_TLD_WHOIS',
    URIBL_RHS_WHOIS: 'URIBL_RHS_WHOIS',
    URIBL_SBL: 'URIBL_SBL',
    URIBL_SBL_A: 'URIBL_SBL_A',
    URIBL_SC_SURBL: 'URIBL_SC_SURBL',
    URIBL_ZEN_BLOCKED: 'URIBL_ZEN_BLOCKED',
    URIBL_ZEN_BLOCKED_OPENDNS: 'URIBL_ZEN_BLOCKED_OPENDNS',
    URI_ADOBESPARKURI_AZURE_CLOUDAPP: 'URI_ADOBESPARKURI_AZURE_CLOUDAPP',
    URI_CLOUDFLAREIPFS: 'URI_CLOUDFLAREIPFS',
    URI_DASHGOVEDU: 'URI_DASHGOVEDU',
    URI_DATA: 'URI_DATA',
    URI_DBL_INDIR: 'URI_DBL_INDIR',
    URI_DEOBFU_INSTR: 'URI_DEOBFU_INSTR',
    URI_DOTDOT_LOW_CNTRST: 'URI_DOTDOT_LOW_CNTRST',
    URI_DOTEDUURI_DOTEDU_ENTITY: 'URI_DOTEDUURI_DOTEDU_ENTITY',
    URI_DOTTY_HEX: 'URI_DOTTY_HEX',
    URI_DQ_UNSUB: 'URI_DQ_UNSUB',
    URI_DWEBIPFS: 'URI_DWEBIPFS',
    URI_EXCESS_SLASHES: 'URI_EXCESS_SLASHES',
    URI_FIREBASEAPP: 'URI_FIREBASEAPP',
    URI_FLKIPFSXYZIPFS: 'URI_FLKIPFSXYZIPFS',
    URI_GOOGDRAWPREVIEWURI_GOOGDRAWPREVIEW_MINFP: 'URI_GOOGDRAWPREVIEWURI_GOOGDRAWPREVIEW_MINFP',
    URI_GOOGLE_DOCS: 'URI_GOOGLE_DOCS',
    URI_GOOGLE_PROXY: 'URI_GOOGLE_PROXY',
    URI_GOOG_STO_SPAMMY: 'URI_GOOG_STO_SPAMMY',
    URI_HEX: 'URI_HEX',
    URI_HEX_IP: 'URI_HEX_IP',
    URI_HIDDEN: 'URI_HIDDEN',
    URI_HIDDEN_2URI_HOST_IN_BLACKLIST: 'URI_HIDDEN_2URI_HOST_IN_BLACKLIST',
    URI_HOST_IN_BLOCKLIST: 'URI_HOST_IN_BLOCKLIST',
    URI_HOST_IN_WELCOMELIST: 'URI_HOST_IN_WELCOMELIST',
    URI_HOST_IN_WHITELIST: 'URI_HOST_IN_WHITELIST',
    URI_IMG_CWINDOWSNET: 'URI_IMG_CWINDOWSNET',
    URI_IMG_WP_REDIRURI_IPFS: 'URI_IMG_WP_REDIRURI_IPFS',
    URI_IPFSIO: 'URI_IPFSIO',
    URI_LONG_REPEAT: 'URI_LONG_REPEAT',
    URI_MALWARE_BH: 'URI_MALWARE_BH',
    URI_MALWARE_CWALL: 'URI_MALWARE_CWALL',
    URI_MALWARE_SCMS: 'URI_MALWARE_SCMS',
    URI_NOCODEFORM: 'URI_NOCODEFORM',
    URI_NOVOWEL: 'URI_NOVOWEL',
    URI_NO_WWW_BIZ_CGIURI_NO_WWW_INFO_CGI: 'URI_NO_WWW_BIZ_CGIURI_NO_WWW_INFO_CGI',
    URI_NUMERIC_CCTLD: 'URI_NUMERIC_CCTLD',
    URI_OBFU_DOM: 'URI_OBFU_DOM',
    URI_OBFU_PROTO: 'URI_OBFU_PROTO',
    URI_OBFU_TLD: 'URI_OBFU_TLD',
    URI_ONLY_LOW_CONTRAST: 'URI_ONLY_LOW_CONTRAST',
    URI_ONLY_MSGID_MALFURI_OPTOUT_3LD: 'URI_ONLY_MSGID_MALFURI_OPTOUT_3LD',
    URI_OPTOUT_USME: 'URI_OPTOUT_USME',
    URI_PHISH: 'URI_PHISH',
    URI_PHP_REDIR: 'URI_PHP_REDIR',
    URI_TRPL_INDIR: 'URI_TRPL_INDIR',
    URI_TRUNCATED: 'URI_TRUNCATED',
    URI_TRY_3LD: 'URI_TRY_3LD',
    URI_TRY_USME: 'URI_TRY_USME',
    URI_UNSUBSCRIBEURI_WPADMIN: 'URI_UNSUBSCRIBEURI_WPADMIN',
    URI_WP_DIRINDEX: 'URI_WP_DIRINDEX',
    URI_WP_HACKED: 'URI_WP_HACKED',
    URI_WP_HACKED_2: 'URI_WP_HACKED_2',
    URL_SHORTENER: 'URL_SHORTENER',
    USB_DRIVES: 'USB_DRIVES',
    USER_IN_ALL_SPAM_TO: 'USER_IN_ALL_SPAM_TO',
    USER_IN_BLACKLISTUSER_IN_BLACKLIST_TO: 'USER_IN_BLACKLISTUSER_IN_BLACKLIST_TO',
    USER_IN_BLOCKLIST: 'USER_IN_BLOCKLIST',
    USER_IN_BLOCKLIST_TO: 'USER_IN_BLOCKLIST_TO',
    USER_IN_DEF_DKIM_WL: 'USER_IN_DEF_DKIM_WL',
    USER_IN_DEF_SPF_WL: 'USER_IN_DEF_SPF_WL',
    USER_IN_DEF_WELCOMELISTUSER_IN_DEF_WHITELIST: 'USER_IN_DEF_WELCOMELISTUSER_IN_DEF_WHITELIST',
    USER_IN_DKIM_WELCOMELIST: 'USER_IN_DKIM_WELCOMELIST',
    USER_IN_DKIM_WHITELIST: 'USER_IN_DKIM_WHITELIST',
    USER_IN_MORE_SPAM_TO: 'USER_IN_MORE_SPAM_TO',
    USER_IN_SPF_WELCOMELIST: 'USER_IN_SPF_WELCOMELIST',
    USER_IN_SPF_WHITELISTUSER_IN_WELCOMELIST: 'USER_IN_SPF_WHITELISTUSER_IN_WELCOMELIST',
    USER_IN_WELCOMELIST_TO: 'USER_IN_WELCOMELIST_TO',
    USER_IN_WHITELIST: 'USER_IN_WHITELIST',
    USER_IN_WHITELIST_TO: 'USER_IN_WHITELIST_TO',
    USING_VERP: 'USING_VERP',
    US_DOLLARS_3: 'US_DOLLARS_3',
    VBOUNCE_MESSAGEVFY_ACCT_NORDNS: 'VBOUNCE_MESSAGEVFY_ACCT_NORDNS',
    VIA_GAP_GRA: 'VIA_GAP_GRA',
    VISTA_COST: 'VISTA_COST',
    VISTA_TONOM_EQ_TOLOC: 'VISTA_TONOM_EQ_TOLOC',
    VPS_NO_NTLD: 'VPS_NO_NTLD',
    VULN_PHPMAILER: 'VULN_PHPMAILER',
    WALMART_IMG_NOT_RCVD_WAL: 'WALMART_IMG_NOT_RCVD_WAL',
    WEIRD_PORTWEIRD_QUOTING: 'WEIRD_PORTWEIRD_QUOTING',
    WIKI_IMG: 'WIKI_IMG',
    WITH_LC_SMTP: 'WITH_LC_SMTP',
    WON_MONEY_ATTACH: 'WON_MONEY_ATTACH',
    WON_NBDY_ATTACH: 'WON_NBDY_ATTACH',
    WORD_INVIS: 'WORD_INVIS',
    WORD_INVIS_MANY: 'WORD_INVIS_MANY',
    XFER_LOTSA_MONEY: 'XFER_LOTSA_MONEY',
    XM_DIGITS_ONLYXM_PHPMAILER_FORGED: 'XM_DIGITS_ONLYXM_PHPMAILER_FORGED',
    XM_RANDOM: 'XM_RANDOM',
    XPRIO: 'XPRIO',
    XPRIO_SHORT_SUBJ: 'XPRIO_SHORT_SUBJ',
    XPRIO_VISTA: 'XPRIO_VISTA',
    X_IP: 'X_IP',
    X_MAILER_CME_6543_MSN: 'X_MAILER_CME_6543_MSN',
    X_MESSAGE_INFO: 'X_MESSAGE_INFO',
    X_PRIORITY_CCYAHOO_DRS_REDIR: 'X_PRIORITY_CCYAHOO_DRS_REDIR',
    YAHOO_RD_REDIR: 'YAHOO_RD_REDIR',
    YOUR_PERMISSION: 'YOUR_PERMISSION',
    YOU_INHERIT: 'YOU_INHERIT',
    local_GOOGLE_LUCKY: 'local_GOOGLE_LUCKY',
};
